(function () {
  const nav = document.getElementById("site-nav");
  const toggle = document.getElementById("menu-toggle");
  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      const open = nav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  document.querySelectorAll("[data-dropdown]").forEach((drop) => {
    const btn = drop.querySelector("button");
    if (!btn) return;
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const open = drop.classList.toggle("open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  document.addEventListener("click", () => {
    document.querySelectorAll("[data-dropdown].open").forEach((d) => {
      d.classList.remove("open");
      const b = d.querySelector("button");
      if (b) b.setAttribute("aria-expanded", "false");
    });
  });

  const searchBtn = document.getElementById("search-btn");
  const searchPanel = document.getElementById("search-panel");
  const searchInput = document.getElementById("search-input");
  if (searchBtn && searchPanel) {
    searchBtn.addEventListener("click", () => {
      const hidden = searchPanel.hasAttribute("hidden");
      if (hidden) {
        searchPanel.removeAttribute("hidden");
        if (searchInput) searchInput.focus();
      } else {
        searchPanel.setAttribute("hidden", "");
      }
    });
  }

  document.querySelectorAll("[data-gallery]").forEach((gallery) => {
    const main = gallery.querySelector("[data-gallery-main]");
    gallery.querySelectorAll("[data-thumb]").forEach((btn) => {
      btn.addEventListener("click", () => {
        gallery.querySelectorAll("[data-thumb]").forEach((b) => b.removeAttribute("aria-current"));
        btn.setAttribute("aria-current", "true");
        if (main) main.src = btn.dataset.src;
      });
    });
  });

  // Swap PDP gallery + price when variant option changes
  document.querySelectorAll("select.variant-select").forEach((select) => {
    const form = select.closest("form") || select.closest(".pdp-info") || document;
    const galleryMain =
      document.querySelector("[data-gallery-main]") ||
      (form.closest(".pdp") && form.closest(".pdp").querySelector("[data-gallery-main]"));
    const fallbackSrc = galleryMain ? galleryMain.getAttribute("src") : "";
    const priceRoot =
      document.querySelector("[data-product-price]") ||
      (form.closest(".pdp-info") && form.closest(".pdp-info").querySelector(".pdp-price"));

    const applyVariant = () => {
      if (!select.options || select.selectedIndex < 0) return;
      const opt = select.options[select.selectedIndex];
      if (!opt) return;
      const img = opt.getAttribute("data-image");
      if (galleryMain) {
        galleryMain.src = img || fallbackSrc || galleryMain.src;
      }
      if (priceRoot) {
        const current = priceRoot.querySelector("[data-price-current]");
        const compare = priceRoot.querySelector("[data-price-compare]");
        const priceText = opt.getAttribute("data-price");
        if (current && priceText) current.textContent = priceText;
        else if (priceText && !current) {
          // plain price node: replace first text while keeping compare span
          const was = priceRoot.querySelector(".was");
          const nodes = [...priceRoot.childNodes];
          for (const n of nodes) {
            if (n.nodeType === Node.TEXT_NODE && n.textContent.trim()) {
              n.textContent = priceText + (was ? " " : "");
              break;
            }
          }
          if (![...priceRoot.childNodes].some((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim()) && !current) {
            priceRoot.insertAdjacentText("afterbegin", priceText + " ");
          }
        }
        const cmp = opt.getAttribute("data-compare");
        if (compare) {
          if (cmp) {
            compare.textContent = cmp;
            compare.hidden = false;
          } else {
            compare.textContent = "";
            compare.hidden = true;
          }
        }
      }
    };

    select.addEventListener("change", applyVariant);
    applyVariant();
  });

  const hideSold = document.getElementById("hide-sold");
  if (hideSold) {
    const apply = () => {
      document.querySelectorAll(".product-card.sold-out").forEach((card) => {
        card.style.display = hideSold.checked ? "none" : "";
      });
      const vis = [...document.querySelectorAll(".product-grid .product-card")].filter(
        (c) => c.style.display !== "none"
      ).length;
      const meta = document.getElementById("results-count");
      if (meta) meta.textContent = vis + " products";
    };
    hideSold.addEventListener("change", apply);
    apply();
  }

  // Required line-item properties on product forms (e.g. TAG grading "Which card(s)?")
  document.querySelectorAll("[data-product-form]").forEach((pf) => {
    pf.addEventListener("submit", (e) => {
      const missing = Array.from(pf.querySelectorAll("[data-required-prop]")).find((el) => !el.value.trim());
      if (missing) {
        e.preventDefault();
        missing.value = "";
        missing.focus();
        window.alert("Please enter the card(s) you want graded.");
      }
    });
  });

  document.querySelectorAll("[data-qty]").forEach((wrap) => {
    const input = wrap.querySelector("input");
    wrap.querySelectorAll("button").forEach((btn) => {
      btn.addEventListener("click", () => {
        const delta = Number(btn.dataset.delta || 0);
        const next = Math.max(1, (Number(input.value) || 1) + delta);
        input.value = next;
      });
    });
  });

  const SHIP_USA = 50472843411689;
  const SHIP_CA = 50472844296425;
  const SHIP_IDS = [SHIP_USA, SHIP_CA];
  const SHIP_HANDLE = "ship-your-bag";

  function jsonPost(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(async (res) => {
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const err = new Error(data.description || data.message || "Cart request failed");
        err.data = data;
        throw err;
      }
      return data;
    });
  }

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
  }

  function isShipItem(item) {
    return item.handle === SHIP_HANDLE || SHIP_IDS.indexOf(item.variant_id) !== -1;
  }

  function shipItem(cart) {
    return cart.items.find(isShipItem);
  }

  async function removeShipping() {
    const cart = await getCart();
    const existing = shipItem(cart);
    if (!existing) return { cart, changed: false };
    await jsonPost("/cart/change.js", { id: existing.key, quantity: 0 });
    return { cart: await getCart(), changed: true };
  }

  async function ensureShipping(want) {
    const cart = await getCart();
    const existing = shipItem(cart);
    if (existing && existing.variant_id === want) return { cart, changed: false };
    if (existing && existing.key) {
      await jsonPost("/cart/change.js", { id: existing.key, quantity: 0 });
    }
    await jsonPost("/cart/add.js", { id: want, quantity: 1 });
    return { cart: await getCart(), changed: true };
  }

  async function applyShipChoice(choice) {
    if (choice === "ca") return ensureShipping(SHIP_CA);
    if (choice === "usa") return ensureShipping(SHIP_USA);
    return removeShipping();
  }


  const cartPage = document.querySelector("[data-cart-page]");
  if (cartPage) {
    const form = cartPage.querySelector("[data-cart-form]");
    const radios = cartPage.querySelectorAll("[data-ship-switch] input[name='ship-region']");

    radios.forEach((radio) => {
      radio.addEventListener("change", async () => {
        radios.forEach((r) => { r.disabled = true; });
        try {
          const result = await applyShipChoice(radio.value);
          if (result.changed) window.location.reload();
        } catch (err) {
          window.alert(err.message || "Could not update shipping");
          radios.forEach((r) => { r.disabled = false; });
        }
      });
    });

    // Shipping add-ons (Signature Required / Extra Shipping Insurance)
    const addonsWrap = cartPage.querySelector("[data-ship-addons]");
    if (addonsWrap) {
      const lockAddons = (on) => {
        addonsWrap.classList.toggle("is-busy", on);
        addonsWrap.querySelectorAll("button").forEach((b) => { b.disabled = on; });
      };
      const addonFail = (err) => {
        window.alert((err && err.message) || "Could not update shipping add-ons");
        window.location.reload();
      };
      const sigRow = addonsWrap.querySelector("[data-addon-signature]");
      if (sigRow) {
        sigRow.querySelectorAll("[data-addon-toggle]").forEach((btn) => {
          btn.addEventListener("click", async () => {
            const key = sigRow.dataset.lineKey;
            lockAddons(true);
            try {
              if (key) await jsonPost("/cart/change.js", { id: key, quantity: 0 });
              else await jsonPost("/cart/add.js", { id: Number(sigRow.dataset.variantId), quantity: 1 });
              window.location.reload();
            } catch (err) { addonFail(err); }
          });
        });
      }
      const insRow = addonsWrap.querySelector("[data-addon-insurance]");
      if (insRow) {
        insRow.querySelectorAll("[data-ins-step]").forEach((btn) => {
          btn.addEventListener("click", async () => {
            const current = Number(insRow.dataset.qty || 0);
            const next = Math.max(0, current + Number(btn.dataset.insStep || 0));
            if (next === current) return;
            const qtyEl = insRow.querySelector("[data-ins-qty]");
            const totalEl = insRow.querySelector("[data-coverage-total]");
            if (qtyEl) qtyEl.textContent = String(next);
            if (totalEl) totalEl.textContent = "$" + (100 + next * 100);
            lockAddons(true);
            try {
              const key = insRow.dataset.lineKey;
              if (key) await jsonPost("/cart/change.js", { id: key, quantity: next });
              else await jsonPost("/cart/add.js", { id: Number(insRow.dataset.variantId), quantity: next });
              window.location.reload();
            } catch (err) { addonFail(err); }
          });
        });
      }
    }

    const sealedBox = cartPage.querySelector("[data-sealed-bypass]");
    const streamFields = cartPage.querySelectorAll("[data-stream-fields]");
    const userInputEl = form ? form.querySelector('[name="attributes[viewer_username]"]') : null;
    const syncSealedBypass = () => {
      const on = !!(sealedBox && sealedBox.checked);
      streamFields.forEach((el) => { el.hidden = on; });
      if (userInputEl) {
        if (on) userInputEl.removeAttribute("required");
        else userInputEl.setAttribute("required", "required");
      }
    };
    if (sealedBox) {
      sealedBox.addEventListener("change", syncSealedBypass);
      syncSealedBypass();
    }

    if (form) {
      form.addEventListener("submit", async (e) => {
        const submitter = e.submitter;
        if (!submitter || submitter.name !== "checkout") return;
        const selected = cartPage.querySelector("[data-ship-switch] input[name='ship-region']:checked");
        const choice = selected ? selected.value : "hold";
        const userInput = form.querySelector('[name="attributes[viewer_username]"]');
        const msgInput = form.querySelector('[name="attributes[viewer_message]"]');
        const sealedOnly = !!(sealedBox && sealedBox.checked);
        const username = userInput ? userInput.value.trim() : "";
        if (!sealedOnly && !username) {
          e.preventDefault();
          if (userInput) userInput.focus();
          window.alert("Add your viewer username so it shows on stream.");
          return;
        }
        e.preventDefault();
        submitter.disabled = true;
        submitter.textContent = choice === "hold" ? "Checking out…" : "Adding shipping…";
        try {
          // Persist Stream Alerts note attributes before shipping / checkout redirect
          await jsonPost("/cart/update.js", {
            attributes: {
              viewer_username: sealedOnly ? "" : username,
              viewer_message: sealedOnly ? "" : (msgInput ? msgInput.value.trim() : ""),
              sealed_only: sealedOnly ? "yes" : "",
            },
          });
          await applyShipChoice(choice);
          const go = document.createElement("input");
          go.type = "hidden";
          go.name = "checkout";
          go.value = "Checkout";
          form.appendChild(go);
          form.submit();
        } catch (err) {
          submitter.disabled = false;
          submitter.textContent = "Checkout";
          window.alert(err.message || "Could not add shipping. Try again.");
        }
      });
    }
  }
})();

/* goadedex — per-Pokémon version unlock model */
(function () {
  const cfg = window.GOADED || {};
  const storageKeyV4 = () =>
    "goaded_caught_v4_" + (cfg.customerId ? String(cfg.customerId) : "guest");
  const storageKeyV3 = () =>
    "goaded_caught_v3_" + (cfg.customerId ? String(cfg.customerId) : "guest");

  /* ---- Chat-command profile (Twitch link + epoch) for !dex ---- */
  const acctSuffix = () => (cfg.customerId ? String(cfg.customerId) : "guest");
  const TWITCH_NAME_RE = /^[a-z0-9_]{4,25}$/;
  function normalizeTwitchName(raw) {
    return String(raw || "").trim().replace(/^@+/, "").toLowerCase();
  }
  function loadTwitchName() {
    try { return localStorage.getItem("goaded_twitch_v1_" + acctSuffix()) || ""; } catch (_) { return ""; }
  }
  function saveTwitchNameLocal(name) {
    try {
      if (name) localStorage.setItem("goaded_twitch_v1_" + acctSuffix(), name);
      else localStorage.removeItem("goaded_twitch_v1_" + acctSuffix());
    } catch (_) {}
  }
  /* YouTube display name / handle (spaces, @, dots, dashes, unicode OK). Mirrors server rules. */
  function normalizeYoutubeName(raw) {
    return String(raw || "").normalize("NFC").replace(/\s+/gu, " ").trim().replace(/^@+/, "").trim();
  }
  function isValidYoutubeName(t) {
    const len = Array.from(t).length;
    if (len < 3 || len > 100) return false;
    if (/[\p{Cc}\p{Cf}\p{Co}\p{Cn}\p{Zl}\p{Zp}]/u.test(t)) return false;
    if (/[{}$<>`\\|"]/.test(t)) return false;
    if (/(https?:|www\.|:\/\/|\.(com|net|org|tv|gg|ly|io)\b)/i.test(t)) return false;
    if (!/[\p{L}\p{N}]/u.test(t)) return false;
    if (/^[!/]/.test(t)) return false;
    if (/(.)\1{9,}/u.test(t)) return false;
    return true;
  }
  function loadYoutubeName() {
    try { return localStorage.getItem("goaded_youtube_v1_" + acctSuffix()) || ""; } catch (_) { return ""; }
  }
  function saveYoutubeNameLocal(name) {
    try {
      if (name) localStorage.setItem("goaded_youtube_v1_" + acctSuffix(), name);
      else localStorage.removeItem("goaded_youtube_v1_" + acctSuffix());
    } catch (_) {}
  }
  /** Dex epoch: bumps on prestige / hard reset so the server REPLACES (not unions) catches. */
  function loadDexEpoch() {
    try {
      const n = parseInt(localStorage.getItem("goaded_epoch_v1_" + acctSuffix()) || "0", 10);
      return Number.isFinite(n) && n > 0 ? n : 0;
    } catch (_) { return 0; }
  }
  function saveDexEpoch(n) {
    try { localStorage.setItem("goaded_epoch_v1_" + acctSuffix(), String(Math.max(0, n | 0))); } catch (_) {}
  }
  function loadPendingReset() {
    try { return parseInt(localStorage.getItem("goaded_pending_reset_v1_" + acctSuffix()) || "0", 10) || 0; } catch (_) { return 0; }
  }
  function setPendingReset(n) {
    try {
      if (n) localStorage.setItem("goaded_pending_reset_v1_" + acctSuffix(), String(n));
      else localStorage.removeItem("goaded_pending_reset_v1_" + acctSuffix());
    } catch (_) {}
  }
  function bumpDexEpoch() {
    const next = loadDexEpoch() + 1;
    saveDexEpoch(next);
    setPendingReset(next);
    return next;
  }
  let twitchDirty = false; // only send twitch when user changed it or we know server value
  let youtubeDirty = false; // same rule for the YouTube name
  function buildSyncProfile() {
    const prof = {
      prestige: 0,
      streak: 0,
      epoch: loadDexEpoch(),
      total: (typeof window !== "undefined" && window.__GOADED_ROSTER_LEN__) || 0,
    };
    try { prof.prestige = loadPrestige().count || 0; } catch (_) {}
    try { prof.streak = loadStreak(); } catch (_) {}
    const tw = loadTwitchName();
    if (tw || twitchDirty) prof.twitch = tw; // "" = unlink
    const yt = loadYoutubeName();
    if (yt || youtubeDirty) prof.youtube = yt; // "" = unlink
    return prof;
  }
  function applyRemoteProfile(rp) {
    if (!rp || typeof rp !== "object") return;
    if (!twitchDirty) saveTwitchNameLocal(rp.twitch || "");
    if (!youtubeDirty) saveYoutubeNameLocal(rp.youtube || "");
    try {
      const meta = loadPrestige();
      if ((rp.prestige | 0) > (meta.count || 0)) {
        savePrestige({ count: rp.prestige | 0, badges: meta.badges || [] });
      }
    } catch (_) {}
    if ((rp.epoch | 0) > loadDexEpoch()) saveDexEpoch(rp.epoch | 0);
    const pend = loadPendingReset();
    if (pend && (rp.epoch | 0) >= pend) setPendingReset(0);
    refreshTwitchLinkUI();
  }
  function scheduleProfileSync() {
    try {
      const map = JSON.parse(localStorage.getItem(storageKeyV4()) || "null") || {};
      scheduleSyncSave(map);
    } catch (_) {}
  }
  function refreshTwitchLinkUI() {
    const input = document.querySelector("[data-twitch-link-input]");
    const status = document.querySelector("[data-twitch-link-status]");
    const ytInput = document.querySelector("[data-youtube-link-input]");
    const tw = loadTwitchName();
    const yt = loadYoutubeName();
    if (input && document.activeElement !== input) input.value = tw;
    if (ytInput && document.activeElement !== ytInput) ytInput.value = yt;
    const linked = [tw, yt].filter(Boolean);
    if (status) status.textContent = linked.length ? "Linked — chat can type !dex " + linked.join(" or !dex ") : "Not linked";
  }
  function mountTwitchLink() {
    if (!cfg.customerId || !cfg.syncUrl) return;
    if (document.querySelector("[data-twitch-link]")) return;
    const head = document.querySelector("[data-goatedex-grid] .goatedex-head > div");
    if (!head) return;
    const wrap = document.createElement("form");
    wrap.className = "goatedex-twitch-link note";
    wrap.setAttribute("data-twitch-link", "");
    wrap.style.cssText = "margin:8px 0 0;display:flex;flex-wrap:wrap;gap:6px;align-items:center";
    wrap.innerHTML =
      '<label for="goatedex-twitch-input" style="font-weight:600">Twitch</label>' +
      '<input id="goatedex-twitch-input" type="text" inputmode="text" autocomplete="off" autocapitalize="none" spellcheck="false"' +
      ' maxlength="26" placeholder="your_twitch_name" data-twitch-link-input' +
      ' style="max-width:180px;padding:4px 8px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:transparent;color:inherit" />' +
      '<label for="goatedex-youtube-input" style="font-weight:600">YouTube name</label>' +
      '<input id="goatedex-youtube-input" type="text" inputmode="text" autocomplete="off" autocapitalize="none" spellcheck="false"' +
      ' maxlength="101" placeholder="@yourhandle or display name" data-youtube-link-input' +
      ' style="max-width:220px;padding:4px 8px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:transparent;color:inherit" />' +
      '<button type="submit" class="btn btn-sm btn-ghost">Save</button>' +
      '<span data-twitch-link-status style="opacity:.8"></span>' +
      '<span style="flex-basis:100%;opacity:.7;font-size:.85em">Optional — lets Goaded Gamer chat (Twitch or YouTube) show your dex with <code>!dex yourname</code>. For YouTube, use the name chat shows for you (usually your @handle). Leave blank to unlink.</span>';
    head.appendChild(wrap);
    wrap.addEventListener("submit", (e) => {
      e.preventDefault();
      const input = wrap.querySelector("[data-twitch-link-input]");
      const status = wrap.querySelector("[data-twitch-link-status]");
      const ytInput = wrap.querySelector("[data-youtube-link-input]");
      const name = normalizeTwitchName(input.value);
      if (name && !TWITCH_NAME_RE.test(name)) {
        status.textContent = "Twitch: 4–25 letters, numbers or _ only";
        return;
      }
      const ytName = ytInput ? normalizeYoutubeName(ytInput.value) : loadYoutubeName();
      if (ytName && !isValidYoutubeName(ytName)) {
        status.textContent = "YouTube: 3–100 characters, no links or symbols like { } $ < >";
        return;
      }
      twitchDirty = true;
      saveTwitchNameLocal(name);
      input.value = name;
      if (ytInput) {
        youtubeDirty = true;
        saveYoutubeNameLocal(ytName);
        ytInput.value = ytName;
      }
      status.textContent = "Saving…";
      const map = (() => {
        try { return JSON.parse(localStorage.getItem(storageKeyV4()) || "null") || {}; } catch (_) { return {}; }
      })();
      if (syncTimer) { clearTimeout(syncTimer); syncTimer = null; }
      postProgress(map).then(() => {
        twitchDirty = false;
        youtubeDirty = false;
        refreshTwitchLinkUI();
      });
    });
    refreshTwitchLinkUI();
  }

  function entryUnlocks(entry) {
    if (Array.isArray(entry)) return entry.slice();
    if (entry && typeof entry === "object" && Array.isArray(entry.unlocks)) {
      return entry.unlocks.slice();
    }
    return [];
  }

  function mergeCaughtMaps(a, b) {
    const out = {};
    const ids = {};
    [a, b].forEach((map) => {
      if (!map || typeof map !== "object") return;
      Object.keys(map).forEach((id) => { ids[id] = true; });
    });
    Object.keys(ids).forEach((id) => {
      const set = new Set();
      entryUnlocks(a && a[id]).forEach((k) => set.add(k));
      entryUnlocks(b && b[id]).forEach((k) => set.add(k));
      if (set.size) out[id] = Array.from(set);
    });
    return out;
  }

  function migrateGuestProgress() {
    if (!cfg.customerId) return;
    try {
      const guestRaw = localStorage.getItem("goaded_caught_v4_guest");
      if (!guestRaw) return;
      const guestMap = JSON.parse(guestRaw);
      if (!guestMap || typeof guestMap !== "object") return;
      const userRaw = localStorage.getItem(storageKeyV4());
      let userMap = {};
      if (userRaw) {
        try { userMap = JSON.parse(userRaw) || {}; } catch (_) { userMap = {}; }
      }
      const merged = mergeCaughtMaps(userMap, guestMap);
      localStorage.setItem(storageKeyV4(), JSON.stringify(merged));
    } catch (_) {}
  }
  migrateGuestProgress();

  /* Account sync via App Proxy (/apps/goatedex) — logged-in only */
  let syncReady = !cfg.customerId;
  let syncTimer = null;
  let syncInFlight = null;
  const listeners = [];

  function notifyProgressSynced(map) {
    listeners.forEach((fn) => {
      try { fn(map); } catch (_) {}
    });
  }

  function scheduleSyncSave(map) {
    if (!cfg.customerId || !cfg.syncUrl) return;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(() => {
      syncTimer = null;
      postProgress(map);
    }, 600);
  }

  function postProgress(map) {
    if (!cfg.customerId || !cfg.syncUrl) return Promise.resolve();
    const body = JSON.stringify({ progress: map, profile: buildSyncProfile() });
    syncInFlight = fetch(cfg.syncUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: body,
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data && data.progress) {
          // keep = server has a newer reset (this device is stale) → adopt server exactly
          const merged =
            data.progressMode === "keep" ? data.progress : mergeCaughtMaps(map, data.progress);
          localStorage.setItem(storageKeyV4(), JSON.stringify(merged));
          applyRemoteProfile(data.profile);
          if (data.progressMode === "keep") notifyProgressSynced(merged);
          return merged;
        }
        return map;
      })
      .catch(() => map)
      .finally(() => { syncInFlight = null; });
    return syncInFlight;
  }

  function pullRemoteProgress() {
    if (!cfg.customerId || !cfg.syncUrl) {
      syncReady = true;
      return Promise.resolve(null);
    }
    return fetch(cfg.syncUrl, {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const remote = (data && data.progress) || cfg.seededProgress || null;
        if (!remote || typeof remote !== "object") return null;
        const local = (() => {
          try {
            return JSON.parse(localStorage.getItem(storageKeyV4()) || "null") || {};
          } catch (_) {
            return {};
          }
        })();
        const rp = data && data.profile;
        const re = rp ? rp.epoch | 0 : 0;
        const le = loadDexEpoch();
        let merged;
        if (rp && re > le) merged = remote; // reset happened on another device
        else if (rp && (re < le || loadPendingReset())) merged = local; // our reset is newer
        else merged = mergeCaughtMaps(local, remote);
        localStorage.setItem(storageKeyV4(), JSON.stringify(merged));
        applyRemoteProfile(rp);
        notifyProgressSynced(merged);
        // Push union back so account has guest/local catches too
        scheduleSyncSave(merged);
        return merged;
      })
      .catch(() => {
        if (cfg.seededProgress && typeof cfg.seededProgress === "object") {
          const local = (() => {
            try {
              return JSON.parse(localStorage.getItem(storageKeyV4()) || "null") || {};
            } catch (_) {
              return {};
            }
          })();
          const merged = mergeCaughtMaps(local, cfg.seededProgress);
          localStorage.setItem(storageKeyV4(), JSON.stringify(merged));
          notifyProgressSynced(merged);
          return merged;
        }
        return null;
      })
      .finally(() => { syncReady = true; });
  }

  if (cfg.customerId && cfg.seededProgress && typeof cfg.seededProgress === "object" && !loadPendingReset()) {
    try {
      const local = JSON.parse(localStorage.getItem(storageKeyV4()) || "null") || {};
      const merged = mergeCaughtMaps(local, cfg.seededProgress);
      localStorage.setItem(storageKeyV4(), JSON.stringify(merged));
    } catch (_) {}
  }
  pullRemoteProgress();

  const ICON_NUMS = new Set([
    25, 6, 9, 3, 130, 150, 151, 94, 144, 145, 146, 149, 133, 448, 384, 249, 250,
    658, 282, 59,
  ]);

  const NORMAL_KEYS = ["gen1", "gen2", "gen3", "gen5", "showdown", "default"];
  const SHINY_KEYS = ["gen3-shiny", "gen5-shiny", "showdown-shiny", "default-shiny"];
  const SHINY_SPAWN_PREF = ["gen3-shiny", "gen5-shiny", "default-shiny", "showdown-shiny"];

  const VERSION_META = {
    gen1: { label: "Gen I", shiny: false },
    gen2: { label: "Gen II", shiny: false },
    gen3: { label: "Gen III", shiny: false },
    gen5: { label: "Gen V", shiny: false },
    showdown: { label: "Showdown", shiny: false },
    default: { label: "Modern", shiny: false },
    "gen3-shiny": { label: "Gen III", shiny: true },
    "gen5-shiny": { label: "Gen V", shiny: true },
    "showdown-shiny": { label: "Showdown", shiny: true },
    "default-shiny": { label: "Modern", shiny: true },
  };

  const BASE = "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon";

  function versionUrl(num, key) {
    switch (key) {
      case "gen1":
        return BASE + "/versions/generation-i/red-blue/transparent/" + num + ".png";
      case "gen2":
        return BASE + "/versions/generation-ii/crystal/transparent/" + num + ".png";
      case "gen3":
        return BASE + "/versions/generation-iii/emerald/" + num + ".png";
      case "gen3-shiny":
        return BASE + "/versions/generation-iii/emerald/shiny/" + num + ".png";
      case "gen5":
        return BASE + "/versions/generation-v/black-white/animated/" + num + ".gif";
      case "gen5-shiny":
        return BASE + "/versions/generation-v/black-white/animated/shiny/" + num + ".gif";
      case "showdown":
        return BASE + "/other/showdown/" + num + ".gif";
      case "showdown-shiny":
        return BASE + "/other/showdown/shiny/" + num + ".gif";
      case "default-shiny":
        // Official painted art (distinct from Gen V / Showdown pixels)
        return BASE + "/other/official-artwork/shiny/" + num + ".png";
      case "default":
        return BASE + "/other/official-artwork/" + num + ".png";
      default:
        return BASE + "/other/official-artwork/" + num + ".png";
    }
  }

  /** @type {Map<string, boolean>} */
  const availCache = new Map();
  function cacheKey(num, key) {
    return String(num) + "|" + key;
  }
  function getCachedAvail(num, key) {
    const k = cacheKey(num, key);
    return availCache.has(k) ? availCache.get(k) : null;
  }
  function setCachedAvail(num, key, ok) {
    availCache.set(cacheKey(num, key), !!ok);
  }
  function probeUrl(url) {
    return new Promise((resolve) => {
      const im = new Image();
      im.onload = () => resolve(true);
      im.onerror = () => resolve(false);
      im.src = url;
    });
  }
  function probeVersion(num, key) {
    const cached = getCachedAvail(num, key);
    if (cached !== null) return Promise.resolve(cached);
    return probeUrl(versionUrl(num, key)).then((ok) => {
      setCachedAvail(num, key, ok);
      return ok;
    });
  }

  function isIcon(p) {
    return ICON_NUMS.has(Number(p.num));
  }
  function candidateKeys(p) {
    const keys = NORMAL_KEYS.slice();
    if (isIcon(p)) keys.push.apply(keys, SHINY_KEYS);
    return keys;
  }
  /** Heuristic before probe — skip gen1–3 for high nums / forms */
  function likelyAvailable(p, key) {
    const num = Number(p.num);
    if (key === "gen1" || key === "gen2" || key === "gen3" || key === "gen3-shiny") {
      if (num > 386) return false;
    }
    // special form IDs rarely have gen5/showdown ani
    if ((num === 10116 || num === 10117) && (key === "showdown" || key === "gen5" || key.indexOf("shiny") !== -1)) {
      return key === "default";
    }
    const cached = getCachedAvail(num, key);
    if (cached === false) return false;
    return true;
  }
  function availableKeysSync(p) {
    return candidateKeys(p).filter((k) => likelyAvailable(p, k));
  }

  function preferredKeyFromSprite(p) {
    const s = String((p && p.sprite) || "");
    if (s.indexOf("/other/showdown/shiny/") !== -1) return "showdown-shiny";
    if (s.indexOf("/other/showdown/") !== -1) return "showdown";
    if (s.indexOf("generation-iii/emerald/shiny") !== -1) return "gen3-shiny";
    if (s.indexOf("generation-iii/emerald") !== -1) return "gen3";
    if (s.indexOf("black-white/animated/shiny") !== -1) return "gen5-shiny";
    if (s.indexOf("black-white/animated") !== -1) return "gen5";
    if (s.indexOf("/shiny/") !== -1) return "default-shiny";
    return "default";
  }

  /** Remap stored unlocks that can't exist for this form (e.g. gen3 on #10012). */
  function coerceVersionKey(p, key) {
    if (key && likelyAvailable(p, key)) return key;
    const pref = preferredKeyFromSprite(p);
    if (likelyAvailable(p, pref)) return pref;
    const fallbacks = isShinyKey(key || "")
      ? ["gen5-shiny", "default-shiny", "showdown-shiny", "gen5", "default", "showdown"]
      : ["gen5", "default", "showdown", "gen3"];
    for (let i = 0; i < fallbacks.length; i++) {
      if (likelyAvailable(p, fallbacks[i])) return fallbacks[i];
    }
    return "default";
  }

  function sanitizeCaughtMap(map, roster) {
    if (!map || typeof map !== "object") return map || {};
    const byId = {};
    if (roster && roster.length) {
      roster.forEach((p) => {
        if (p && p.id) byId[p.id] = p;
      });
    }
    let changed = false;
    Object.keys(map).forEach((id) => {
      const list = map[id];
      if (!Array.isArray(list) || !list.length) return;
      const num = Number(String(id).replace(/^poke-/, "")) || 0;
      const stub = byId[id] || { id: id, num: num, sprite: "" };
      const next = [];
      list.forEach((k) => {
        const ck = coerceVersionKey(stub, k);
        if (next.indexOf(ck) === -1) next.push(ck);
        if (ck !== k) changed = true;
      });
      if (next.join("|") !== list.join("|")) changed = true;
      map[id] = next;
    });
    if (changed) saveCaughtMap(map);
    return map;
  }

  function migrateFromV3() {
    try {
      const raw = JSON.parse(localStorage.getItem(storageKeyV3()) || "[]");
      if (!Array.isArray(raw) || !raw.length) return {};
      const map = {};
      raw.forEach((id) => {
        if (typeof id !== "string") return;
        let pokeId = id;
        let numHint = 0;
        if (id.indexOf("shiny-") === 0) {
          numHint = Number(id.slice(6)) || 0;
          pokeId = "poke-" + numHint;
        } else if (id.indexOf("poke-") === 0) {
          numHint = Number(id.slice(5)) || 0;
        }
        let ver = numHint > 386 ? "default" : "gen3";
        if (id.indexOf("shiny-") === 0) {
          ver = numHint > 386 ? "default-shiny" : "gen3-shiny";
        }
        if (!map[pokeId]) map[pokeId] = [];
        if (map[pokeId].indexOf(ver) === -1) map[pokeId].push(ver);
      });
      return map;
    } catch (_) {
      return {};
    }
  }

  function loadCaughtMap() {
    try {
      const raw = JSON.parse(localStorage.getItem(storageKeyV4()) || "null");
      if (raw && typeof raw === "object" && !Array.isArray(raw)) return sanitizeCaughtMap(raw);
    } catch (_) {}
    const migrated = sanitizeCaughtMap(migrateFromV3());
    if (Object.keys(migrated).length) saveCaughtMap(migrated);
    return migrated;
  }
  function saveCaughtMap(map) {
    localStorage.setItem(storageKeyV4(), JSON.stringify(map));
    scheduleSyncSave(map);
  }

  /* Prestige meta (separate from catches — never wipe without explicit flow) */
  const prestigeKey = () =>
    "goaded_prestige_v1_" + (cfg.customerId ? String(cfg.customerId) : "guest");
  const partnerKey = () =>
    "goaded_partner_v1_" + (cfg.customerId ? String(cfg.customerId) : "guest");
  const streakKey = () =>
    "goaded_streak_v1_" + (cfg.customerId ? String(cfg.customerId) : "guest");
  const shinyDayKey = () =>
    "goaded_shiny_day_v1_" + (cfg.customerId ? String(cfg.customerId) : "guest");

  /** Classic Kanto starters only — first-catch choose-your-starter flow. */
  const STARTER_NUMS = [1, 4, 7];
  const STARTER_VERSION = "gen3";

  /** Classic Indigo League 8 — next gym badge each prestige; ★ overflow after 8. */
  const GYM_BADGES = [
    { id: "boulder", name: "Boulder", short: "BOU", color: "#c8b890", glyph: "◆" },
    { id: "cascade", name: "Cascade", short: "CAS", color: "#5CBCFF", glyph: "◈" },
    { id: "thunder", name: "Thunder", short: "THU", color: "#FFE566", glyph: "⚡" },
    { id: "rainbow", name: "Rainbow", short: "RAI", color: "#FF7AD9", glyph: "✧" },
    { id: "soul", name: "Soul", short: "SOU", color: "#C87AFF", glyph: "◎" },
    { id: "marsh", name: "Marsh", short: "MAR", color: "#B8E050", glyph: "❖" },
    { id: "volcano", name: "Volcano", short: "VOL", color: "#FF8A4A", glyph: "▲" },
    { id: "earth", name: "Earth", short: "EAR", color: "#D4A86A", glyph: "■" },
  ];

  function gymBadgeImgUrl(def) {
    if (!def || !def.id) return "";
    try {
      const map = (window.GOADED && window.GOADED.gymBadges) || {};
      return map[def.id] || "";
    } catch (_) {
      return "";
    }
  }
  function gymBadgeImgHtml(def, cls) {
    const url = gymBadgeImgUrl(def);
    const c = cls || "goatedex-gym-art";
    if (url) {
      return (
        '<img class="' +
        c +
        '" src="' +
        url +
        '" alt="" width="32" height="32" decoding="async" draggable="false" />'
      );
    }
    return (
      '<span class="goatedex-gym-glyph" aria-hidden="true">' +
      (def && def.glyph ? def.glyph : "★") +
      "</span>"
    );
  }
  const PRESTIGE_SCALE_CAP = 10;

  /* Lab-only tester tools — this constant lives ONLY in the Lab theme copy.
     Still no-ops unless Shopify theme id / preview_theme_id is the Lab theme,
     and hard-refuses the live theme id if assets ever leaked. */
  const LAB_TEST_TOOLS = false;
  const LAB_THEME_ID = "162801811689";
  const LIVE_THEME_ID_FORBIDDEN = "162081800425";

  function readShopifyThemeId() {
    try {
      if (window.Shopify && Shopify.theme && Shopify.theme.id != null) {
        return String(Shopify.theme.id);
      }
    } catch (_) {}
    return "";
  }
  function readPreviewThemeId() {
    try {
      return String(new URLSearchParams(location.search).get("preview_theme_id") || "");
    } catch (_) {}
    return "";
  }
  function isLabTestToolsEnabled() {
    if (LAB_TEST_TOOLS !== true) return false;
    const themeId = readShopifyThemeId();
    const previewId = readPreviewThemeId();
    if (themeId === LIVE_THEME_ID_FORBIDDEN || previewId === LIVE_THEME_ID_FORBIDDEN) return false;
    if (themeId === LAB_THEME_ID || previewId === LAB_THEME_ID) return true;
    return false;
  }

  /** Prestige setter — disabled on live build. */
  function labSetPrestige(n) {
    return null; // LIVE BUILD stripped
    if (!isLabTestToolsEnabled()) return null;
    const count = Math.max(0, Math.min(PRESTIGE_SCALE_CAP, Math.floor(Number(n) || 0)));
    const prev = loadPrestige();
    const meta = {
      count: count,
      badges: synthesizeBadges(count, prev.badges || []),
    };
    savePrestige(meta);
    const rosterLen = window.__GOADED_ROSTER_LEN__ || 0;
    refreshPrestigeUI(rosterLen);
    updateLabPrestigePanelStatus(meta);
    return meta;
  }
  function labBumpPrestige(delta) {
    return null; // LIVE BUILD stripped
    if (!isLabTestToolsEnabled()) return null;
    const cur = loadPrestige().count || 0;
    return labSetPrestige(cur + (Number(delta) || 0));
  }
  function updateLabPrestigePanelStatus(meta) { /* LIVE stripped */ }
  function mountLabPrestigePanel() {
    /* LIVE BUILD: lab prestige tester permanently stripped — never mount */
    return;
  }


  function gymBadgeDef(index0) {
    if (index0 < 0) return null;
    if (index0 < GYM_BADGES.length) return GYM_BADGES[index0];
    return {
      id: "star-" + (index0 - GYM_BADGES.length + 1),
      name: "★×" + (index0 - GYM_BADGES.length + 1),
      short: "★",
      color: "#ffe56a",
      glyph: "★",
      overflow: true,
    };
  }

  function synthesizeBadges(count, existing) {
    const n = Math.max(0, Number(count) || 0);
    const out = [];
    const prev = Array.isArray(existing) ? existing : [];
    for (let i = 0; i < n; i++) {
      const def = gymBadgeDef(i);
      const old = prev[i];
      if (old && typeof old === "object") {
        out.push({
          id: old.id || def.id,
          name: old.name || def.name,
          short: (function () {
            const s = String(old.short || def.short || "").toUpperCase();
            if (s === "BLD") return "BOU";
            if (s === "RBN") return "RAI";
            return old.short || def.short;
          })(),
          color: old.color || def.color,
          glyph: old.glyph || def.glyph,
          at: old.at || Date.now(),
          overflow: !!def.overflow || !!old.overflow,
        });
      } else {
        out.push({
          id: def.id,
          name: def.name,
          short: def.short,
          color: def.color,
          glyph: def.glyph,
          at: Date.now(),
          overflow: !!def.overflow,
        });
      }
    }
    return out;
  }

  function normalizePrestige(raw) {
    // Migrate safely: bare number, {count}, or full {count,badges}
    let count = 0;
    let badges = [];
    if (typeof raw === "number" || (typeof raw === "string" && String(raw).trim() !== "" && !isNaN(Number(raw)))) {
      count = Math.max(0, Math.floor(Number(raw)) || 0);
      badges = synthesizeBadges(count, []);
    } else if (raw && typeof raw === "object") {
      count = Math.max(0, Math.floor(Number(raw.count) || 0));
      badges = Array.isArray(raw.badges) ? raw.badges.slice() : [];
      // If count > badges length (old Bronze/Silver schema), fill gym badges — never wipe
      if (count > badges.length) {
        badges = synthesizeBadges(count, badges);
      } else if (badges.length > count) {
        // Prefer badges length if somehow ahead (do not wipe badges)
        count = badges.length;
      }
      // Backfill missing gym fields on existing entries
      badges = synthesizeBadges(count, badges);
    }
    return { count: count, badges: badges };
  }

  function loadPrestige() {
    try {
      const raw = JSON.parse(localStorage.getItem(prestigeKey()) || "null");
      if (raw === null || raw === undefined) return { count: 0, badges: [] };
      const meta = normalizePrestige(raw);
      // Persist migration quietly so old number/{count} become full schema
      try {
        const wasPlain =
          typeof raw === "number" ||
          (raw && typeof raw === "object" && (!Array.isArray(raw.badges) || raw.badges.length < meta.count));
        if (wasPlain && meta.count > 0) savePrestige(meta);
      } catch (_) {}
      return meta;
    } catch (_) {}
    return { count: 0, badges: [] };
  }
  function savePrestige(meta) {
    const normalized = normalizePrestige(meta || { count: 0, badges: [] });
    localStorage.setItem(prestigeKey(), JSON.stringify(normalized));
    scheduleProfileSync();
  }
  function prestigeTierName(n) {
    if (n <= 0) return null;
    const def = gymBadgeDef(n - 1);
    return def ? def.name + " Badge" : "Gym Badge";
  }
  function prestigeBadgeLabel(meta) {
    const n = meta.count || 0;
    if (n <= 0) return "";
    if (n <= GYM_BADGES.length) return GYM_BADGES[n - 1].name;
    return "★×" + (n - GYM_BADGES.length);
  }
  function typePillLabel(name) {
    const n = String(name || "").toUpperCase();
    const abbrev = {
      DRAGON: "DRG",
      ELECTRIC: "ELC",
      FIGHTING: "FTG",
      PSYCHIC: "PSY",
      GROUND: "GRD",
      FLYING: "FLY",
      POISON: "PSN",
      NORMAL: "NRM",
      STEEL: "STL",
      FAIRY: "FRY",
      GHOST: "GST",
      DARK: "DRK",
      WATER: "WTR",
      GRASS: "GRS",
      FIRE: "FIR",
      ICE: "ICE",
      BUG: "BUG",
      ROCK: "RCK",
    };
    if (abbrev[n]) return abbrev[n];
    if (n.length > 5) return n.slice(0, 3);
    return n;
  }
  function battleScaleForPrestige(n) {
    const rank = Math.min(PRESTIGE_SCALE_CAP, Math.max(0, Number(n) || 0));
    // Soft caps stay fair on mobile: zone floor ~8.5%, modest speed bump
    return {
      rank: rank,
      zoneShrink: rank * 0.55,
      speedBump: rank * 0.055,
      zoneFloor: 8.5,
    };
  }

  const HIT_RARITY_CAP = 4;
  const HIT_TOTAL_CAP = 7;
  const PSEUDO_NUMS = new Set([149, 248, 373, 376, 445, 635, 706, 784, 887, 998]);
  const LEGENDARY_NUMS = new Set([
    144, 145, 146, 150, 151, 243, 244, 245, 249, 250, 251,
    377, 378, 379, 380, 381, 382, 383, 384, 385, 386,
    480, 481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493,
    494, 638, 639, 640, 641, 642, 643, 644, 645, 646, 647, 648, 649,
    716, 717, 718, 719, 720, 721,
    772, 773, 785, 786, 787, 788, 789, 790, 791, 792, 793, 794, 795, 796, 797, 798, 799,
    800, 801, 802, 803, 804, 805, 806, 807, 808, 809,
    888, 889, 890, 891, 892, 893, 894, 895, 896, 897, 898,
    905, 1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1014, 1015, 1016, 1017, 1024, 1025,
  ]);

  function isPseudo(p) {
    return PSEUDO_NUMS.has(Number(p && p.num));
  }
  function isLegendaryish(p) {
    const num = Number(p && p.num);
    if (LEGENDARY_NUMS.has(num)) return true;
    // Mega / form shells in PokeAPI often live above 10000
    if (num >= 10000 && num < 11000) return true;
    return false;
  }
  function isHigherForm(p) {
    return Number(p && p.num) >= 10000;
  }
  /**
   * Wild HP / hits: rarity base + shiny +1, then +1 per prestige, soft-capped for mobile.
   * Trainer fights add +1 on top (still capped).
   */
  function wildHitBudget(poke, shiny, prestigeCount, opts) {
    opts = opts || {};
    let rarityHits = 1;
    if (isLegendaryish(poke)) rarityHits = 3;
    else if (isIcon(poke) || isPseudo(poke) || isHigherForm(poke)) rarityHits = 2;
    if (shiny) rarityHits += 1;
    rarityHits = Math.min(HIT_RARITY_CAP, Math.max(1, rarityHits));
    const prestigeBonus = Math.min(PRESTIGE_SCALE_CAP, Math.max(0, Number(prestigeCount) || 0));
    let hits = rarityHits + prestigeBonus;
    if (opts.trainer) hits += 1;
    hits = Math.min(HIT_TOTAL_CAP, hits);
    return {
      hits: hits,
      maxHp: hits,
      prestigeBonus: prestigeBonus,
      rarityHits: rarityHits,
      trainerBonus: opts.trainer ? 1 : 0,
    };
  }

  function loadStreak() {
    try {
      const n = parseInt(localStorage.getItem(streakKey()) || "0", 10);
      return Number.isFinite(n) && n > 0 ? n : 0;
    } catch (_) {
      return 0;
    }
  }
  function saveStreak(n) {
    const v = Math.max(0, Math.floor(Number(n) || 0));
    try {
      localStorage.setItem(streakKey(), String(v));
    } catch (_) {}
    scheduleProfileSync();
    return v;
  }
  function bumpStreak() {
    return saveStreak(loadStreak() + 1);
  }
  function resetStreak() {
    return saveStreak(0);
  }
  function refreshStreakChip(n) {
    const count = n == null ? loadStreak() : n;
    document.querySelectorAll("[data-streak-chip]").forEach((el) => {
      if (count >= 2) {
        el.hidden = false;
        el.removeAttribute("hidden");
        el.textContent = "🔥 streak ×" + count;
        el.title = count + " consecutive catches";
        el.setAttribute("aria-hidden", "false");
      } else {
        el.hidden = true;
        el.setAttribute("hidden", "");
        el.textContent = "";
        el.setAttribute("aria-hidden", "true");
      }
    });
    let field = document.querySelector(".goaded-streak-field");
    if (count >= 2) {
      if (!field) {
        field = document.createElement("div");
        field.className = "goaded-streak-field";
        field.setAttribute("data-streak-chip", "");
        document.body.appendChild(field);
      }
      field.hidden = false;
      field.removeAttribute("hidden");
      field.textContent = "🔥 streak ×" + count;
      field.title = count + " consecutive catches";
    } else if (field) {
      field.hidden = true;
      field.setAttribute("hidden", "");
      field.textContent = "";
    }
  }

  function localDateKey() {
    const d = new Date();
    return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
  }
  function loadShinyDay() {
    try {
      return localStorage.getItem(shinyDayKey()) || "";
    } catch (_) {
      return "";
    }
  }
  function markShinyDay(dateStr) {
    try {
      localStorage.setItem(shinyDayKey(), dateStr || localDateKey());
    } catch (_) {}
  }
  function maybeFirstShinyToday(poke) {
    const today = localDateKey();
    if (loadShinyDay() === today) return false;
    markShinyDay(today);
    showFirstShinyDayJuice(poke);
    return true;
  }
  function showFirstShinyDayJuice(poke) {
    let layer = document.querySelector(".goaded-shiny-day");
    if (!layer) {
      layer = document.createElement("div");
      layer.className = "goaded-shiny-day";
      layer.setAttribute("aria-live", "polite");
      document.body.appendChild(layer);
    }
    layer.innerHTML =
      '<div class="goaded-shiny-day-vignette" aria-hidden="true"></div>' +
      '<div class="goaded-shiny-day-toast">✦ First shiny today' +
      (poke && poke.name ? " · " + poke.name : "") +
      "</div>";
    const parts = document.createElement("div");
    parts.className = "goaded-shiny-day-parts";
    parts.setAttribute("aria-hidden", "true");
    for (let i = 0; i < 12; i++) {
      const s = document.createElement("span");
      s.style.setProperty("--i", String(i));
      s.style.setProperty("--x", (10 + Math.random() * 80).toFixed(1) + "vw");
      s.style.setProperty("--d", (0.5 + Math.random() * 0.8).toFixed(2) + "s");
      parts.appendChild(s);
    }
    layer.appendChild(parts);
    layer.classList.add("is-on");
    clearTimeout(showFirstShinyDayJuice._t);
    showFirstShinyDayJuice._t = setTimeout(() => {
      layer.classList.remove("is-on");
      layer.innerHTML = "";
    }, 3200);
  }

  function downloadShareCard() {
    const map = loadCaughtMap();
    const caught = speciesCaughtCount(map);
    const prog = document.querySelector("[data-goatedex-progress]");
    let total = window.__GOADED_ROSTER_LEN__ || 0;
    if (prog && /\//.test(prog.textContent || "")) {
      const t = parseInt(String(prog.textContent).split("/")[1].replace(/[^0-9]/g, ""), 10);
      if (t > 0) total = t;
    }
    if (!total) {
      try {
        const grid = document.querySelectorAll("[data-goatedex-grid] .goatedex-cell[data-poke-id]");
        if (grid && grid.length) total = grid.length;
      } catch (_) {}
    }
    const meta = loadPrestige();
    const partner = loadPartner();
    const w = 720;
    const h = 420;
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    const grd = ctx.createLinearGradient(0, 0, w, h);
    grd.addColorStop(0, "#0c120c");
    grd.addColorStop(0.55, "#142018");
    grd.addColorStop(1, "#0a0e0a");
    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, w, h);
    ctx.strokeStyle = "rgba(140,255,58,0.45)";
    ctx.lineWidth = 4;
    ctx.strokeRect(12, 12, w - 24, h - 24);
    ctx.strokeStyle = "rgba(230,195,92,0.35)";
    ctx.lineWidth = 2;
    ctx.strokeRect(22, 22, w - 44, h - 44);
    ctx.fillStyle = "#8cff3a";
    ctx.font = "700 28px system-ui,Segoe UI,sans-serif";
    ctx.fillText("GOADED · Goatédex", 48, 64);
    ctx.fillStyle = "rgba(255,255,255,0.55)";
    ctx.font = "500 14px system-ui,Segoe UI,sans-serif";
    ctx.fillText("Catch while you shop", 48, 88);
    const totalLabel = total > 0 ? String(total) : "…";
    ctx.fillStyle = "#fff";
    ctx.font = "700 42px system-ui,Segoe UI,sans-serif";
    ctx.fillText(caught + " / " + totalLabel, 48, 160);
    ctx.fillStyle = "rgba(255,255,255,0.65)";
    ctx.font = "600 16px system-ui,Segoe UI,sans-serif";
    ctx.fillText("species caught", 48, 186);
    const rank = meta.count || 0;
    const latest = rank > 0 ? prestigeBadgeLabel(meta) : "—";
    ctx.fillStyle = "#ffe56a";
    ctx.font = "700 20px system-ui,Segoe UI,sans-serif";
    ctx.fillText("Gym rank " + rank, 48, 240);
    ctx.fillStyle = "#e6c35c";
    ctx.font = "600 18px system-ui,Segoe UI,sans-serif";
    ctx.fillText("Latest badge: " + latest, 48, 270);
    const streak = loadStreak();
    if (streak >= 2) {
      ctx.fillStyle = "#ffb06a";
      ctx.font = "600 16px system-ui,Segoe UI,sans-serif";
      ctx.fillText("🔥 streak ×" + streak, 48, 300);
    }
    let partnerName = "No partner";
    if (partner && partner.id) {
      const chip = document.querySelector("[data-partner-chip]");
      partnerName = (chip && chip.textContent && chip.textContent.trim()) || String(partner.id).replace(/^poke-/, "#");
    }
    ctx.fillStyle = "rgba(255,255,255,0.7)";
    ctx.font = "600 15px system-ui,Segoe UI,sans-serif";
    ctx.fillText("Partner: " + partnerName, 48, 340);
    ctx.fillStyle = "rgba(140,255,58,0.55)";
    ctx.font = "600 13px system-ui,Segoe UI,sans-serif";
    ctx.fillText("goadedshop.com/pages/goatedex", 48, 388);

    const finishDownload = () => {
      canvas.toBlob((blob) => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "goatedex-share-card.png";
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1500);
        const toast = ensureToast();
        toast.innerHTML = "Share card saved";
        toast.classList.remove("is-shiny", "is-flee");
        toast.classList.add("is-on");
        clearTimeout(showToast._t);
        showToast._t = setTimeout(() => toast.classList.remove("is-on"), 2200);
      }, "image/png");
    };

    if (partner && partner.id) {
      const num = Number(String(partner.id).replace(/^poke-/, "")) || 0;
      const vk = partner.versionKey || "default";
      const img = new Image();
      img.crossOrigin = "anonymous";
      let settled = false;
      const done = () => {
        if (settled) return;
        settled = true;
        finishDownload();
      };
      img.onload = () => {
        try {
          ctx.drawImage(img, w - 220, 100, 160, 160);
        } catch (_) {}
        done();
      };
      img.onerror = done;
      try {
        img.src = versionUrl(num, vk);
      } catch (_) {
        done();
      }
      setTimeout(done, 1200);
    } else {
      finishDownload();
    }
  }

  function bindShareCardButton() {
    const btn = document.querySelector("[data-share-card-btn]");
    if (!btn || btn.dataset.bound === "1") return;
    btn.dataset.bound = "1";
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      downloadShareCard();
    });
  }

  const TRAINER_NAMES = [
    "Cooltrainer Alex", "Bug Catcher Remy", "Ace Trainer Kai", "Hiker Jordan",
    "Picnicker Sage", "Punk Gio", "Scientist Quinn", "Rocker Vale",
  ];

  function isNightHours() {
    const h = new Date().getHours();
    return h >= 20 || h < 6;
  }

  /**
   * Trainer encounter chance — smooth catch-streak scaling (hot-streak luck, not jackpot).
   * Day:  base 2% + min(2%, streak × 0.25%)  → streak 8+ caps at 4%.
   * Night: +1% on top of the day chance (unchanged tiny night bump).
   */
  function trainerEncounterChance(streak) {
    const s = Math.max(0, Number(streak) || 0);
    const streakBonus = Math.min(0.02, s * 0.0025);
    let chance = 0.02 + streakBonus;
    if (isNightHours()) chance += 0.01;
    return chance;
  }

  function shouldTrainerEncounter() {
    return Math.random() < trainerEncounterChance(loadStreak());
  }

  function buildTrainerParty(roster, map, seedPoke) {
    const size = 2 + (Math.random() < 0.45 ? 1 : 0);
    const incomplete = [];
    const complete = [];
    (roster || []).forEach((p) => {
      if (!p || !p.id) return;
      const unlocked = unlockedFor(map, p.id);
      const keys = availableKeysSync(p);
      if (!unlocked.length || unlocked.length < keys.length) incomplete.push(p);
      else complete.push(p);
    });
    const pool = incomplete.length >= size ? incomplete : incomplete.concat(complete);
    const picks = [];
    const used = {};
    if (seedPoke && seedPoke.id) {
      picks.push(seedPoke);
      used[seedPoke.id] = true;
    }
    // Prefer mix: icons / legendaries sprinkled
    const weighted = pool.slice().sort(() => Math.random() - 0.5);
    for (let i = 0; i < weighted.length && picks.length < size; i++) {
      const p = weighted[i];
      if (used[p.id]) continue;
      // slight bias toward incomplete + rare
      const rare = isLegendaryish(p) || isIcon(p) || isPseudo(p);
      if (rare && Math.random() < 0.35 && picks.length + 1 < size) {
        /* keep rolling rare into mid slots */
      }
      picks.push(p);
      used[p.id] = true;
    }
    while (picks.length < size && roster && roster.length) {
      const p = roster[Math.floor(Math.random() * roster.length)];
      if (!p || used[p.id]) continue;
      picks.push(p);
      used[p.id] = true;
    }
    return picks.map((p) => {
      const missing = missingKeys(p, map);
      let versionKey;
      if (missing.length) versionKey = missing[Math.floor(Math.random() * missing.length)];
      else {
        const avail = availableKeysSync(p);
        versionKey = avail[Math.floor(Math.random() * avail.length)] || "default";
      }
      return { poke: p, versionKey: versionKey, shiny: isShinyKey(versionKey) };
    });
  }

  function renderPartyPips(el, total, index0) {
    if (!el) return;
    let html = "";
    const allDown = index0 >= total;
    for (let i = 0; i < total; i++) {
      const cls = allDown || i < index0 ? " is-down" : i === index0 ? " is-active" : "";
      html += '<span class="goaded-battle-pip' + cls + '" aria-hidden="true"></span>';
    }
    el.innerHTML = html;
    el.hidden = false;
    el.removeAttribute("hidden");
    el.setAttribute(
      "aria-label",
      allDown ? "Trainer party defeated" : "Trainer party " + (index0 + 1) + " of " + total
    );
  }

  /**
   * Trainer challenge: party of 2–3, fight in order, soft flee anytime = no catches + streak reset.
   * Full clear unlocks every party version in one go.
   */
  function runTrainerBattle(roster, seedPoke) {
    return new Promise((resolve) => {
      const map = loadCaughtMap();
      const party = buildTrainerParty(roster, map, seedPoke);
      if (!party.length) {
        resolve({ won: false, party: [] });
        return;
      }
      const trainerName = TRAINER_NAMES[Math.floor(Math.random() * TRAINER_NAMES.length)];
      let idx = 0;

      const fightNext = () => {
        if (idx >= party.length) {
          resolve({ won: true, party: party, trainerName: trainerName });
          return;
        }
        const member = party[idx];
        runBattleMinigame(member.poke, member.versionKey, member.shiny, roster, {
          trainer: true,
          trainerName: trainerName,
          partyIndex: idx,
          partySize: party.length,
          keepOpen: idx < party.length - 1,
          introBanner:
            idx === 0
              ? "Trainer challenge! · " + trainerName
              : "Trainer sent out <strong>" + member.poke.name + "</strong>!",
        }).then((won) => {
          if (!won) {
            resolve({ won: false, party: party, trainerName: trainerName, fledAt: idx });
            return;
          }
          idx += 1;
          fightNext();
        });
      };
      fightNext();
    });
  }



  function loadPartner() {
    try {
      const raw = JSON.parse(localStorage.getItem(partnerKey()) || "null");
      if (raw && raw.id) return { id: String(raw.id), versionKey: raw.versionKey || null };
    } catch (_) {}
    return null;
  }
  function savePartner(partner) {
    if (!partner || !partner.id) {
      localStorage.removeItem(partnerKey());
      return;
    }
    localStorage.setItem(partnerKey(), JSON.stringify({ id: partner.id, versionKey: partner.versionKey || null }));
  }

  /** Lightweight type tint for arena skins (roster has no types). */
  const TYPE_PALETTE = {
    grass: { hue: 110, name: "Grass", accent: "#7CFF6A" },
    fire: { hue: 18, name: "Fire", accent: "#FF8A4A" },
    water: { hue: 205, name: "Water", accent: "#5CBCFF" },
    electric: { hue: 48, name: "Electric", accent: "#FFE566" },
    psychic: { hue: 310, name: "Psychic", accent: "#FF7AD9" },
    fighting: { hue: 8, name: "Fighting", accent: "#E07050" },
    poison: { hue: 280, name: "Poison", accent: "#C87AFF" },
    ground: { hue: 35, name: "Ground", accent: "#D4A86A" },
    flying: { hue: 220, name: "Flying", accent: "#A8C8FF" },
    bug: { hue: 85, name: "Bug", accent: "#B8E050" },
    rock: { hue: 40, name: "Rock", accent: "#C8B890" },
    ghost: { hue: 265, name: "Ghost", accent: "#9A7AFF" },
    ice: { hue: 190, name: "Ice", accent: "#A8F0FF" },
    dragon: { hue: 250, name: "Dragon", accent: "#7A6AFF" },
    dark: { hue: 0, name: "Dark", accent: "#8A8090" },
    steel: { hue: 210, name: "Steel", accent: "#C0D0E0" },
    fairy: { hue: 330, name: "Fairy", accent: "#FFB0D8" },
    normal: { hue: 60, name: "Normal", accent: "#D0D0B8" },
  };
  const TYPE_BY_NUM = {
    1:"grass",2:"grass",3:"grass",4:"fire",5:"fire",6:"fire",7:"water",8:"water",9:"water",
    10:"bug",11:"bug",12:"bug",13:"bug",14:"bug",15:"bug",16:"flying",17:"flying",18:"flying",
    19:"normal",20:"normal",21:"flying",22:"flying",23:"poison",24:"poison",25:"electric",26:"electric",
    27:"ground",28:"ground",29:"poison",30:"poison",31:"poison",32:"poison",33:"poison",34:"poison",
    35:"fairy",36:"fairy",37:"fire",38:"fire",39:"fairy",40:"fairy",41:"poison",42:"poison",
    43:"grass",44:"grass",45:"grass",46:"bug",47:"bug",48:"bug",49:"bug",50:"ground",51:"ground",
    52:"normal",53:"normal",54:"water",55:"water",56:"fighting",57:"fighting",58:"fire",59:"fire",
    60:"water",61:"water",62:"water",63:"psychic",64:"psychic",65:"psychic",66:"fighting",67:"fighting",68:"fighting",
    69:"grass",70:"grass",71:"grass",72:"water",73:"water",74:"rock",75:"rock",76:"rock",
    77:"fire",78:"fire",79:"water",80:"water",81:"electric",82:"electric",83:"flying",84:"flying",85:"flying",
    86:"water",87:"water",88:"poison",89:"poison",90:"water",91:"water",92:"ghost",93:"ghost",94:"ghost",
    95:"rock",96:"psychic",97:"psychic",98:"water",99:"water",100:"electric",101:"electric",
    102:"grass",103:"grass",104:"ground",105:"ground",106:"fighting",107:"fighting",108:"normal",
    109:"poison",110:"poison",111:"ground",112:"ground",113:"normal",114:"grass",115:"normal",
    116:"water",117:"water",118:"water",119:"water",120:"water",121:"water",122:"psychic",
    123:"bug",124:"ice",125:"electric",126:"fire",127:"bug",128:"normal",129:"water",130:"water",
    131:"water",132:"normal",133:"normal",134:"water",135:"electric",136:"fire",137:"normal",
    138:"rock",139:"rock",140:"rock",141:"rock",142:"rock",143:"normal",144:"ice",145:"electric",
    146:"fire",147:"dragon",148:"dragon",149:"dragon",150:"psychic",151:"psychic",
    249:"psychic",250:"fire",282:"fairy",384:"dragon",448:"fighting",658:"water",
    571:"dark",800:"psychic",981:"normal",10155:"psychic",10156:"psychic",10157:"psychic",10239:"normal",
  };
  function inferType(poke) {
    const num = Number(poke && poke.num) || 0;
    if (TYPE_BY_NUM[num]) return TYPE_BY_NUM[num];
    const keys = Object.keys(TYPE_PALETTE);
    return keys[num % keys.length];
  }
  function typeMeta(poke) {
    const t = inferType(poke);
    return Object.assign({ key: t }, TYPE_PALETTE[t] || TYPE_PALETTE.normal);
  }

  const MOVE_FLAVOR = [
    "Neon Slash", "Goated Tackle", "Pixel Punch", "Critter Crush",
    "Shopkeeper Strike", "Hype Beam", "Loot Lunge", "Streamer Slam",
    "Voucher Volt", "Cart Crash", "FOMO Fang", "Clip Cannon",
  ];
  function pickMoveName(poke, shiny) {
    if (shiny) return "✦ Shiny Burst";
    const t = inferType(poke);
    const typed = {
      fire: "Ember Rush", water: "Hydro Tap", grass: "Leaf Flick",
      electric: "Spark Snap", psychic: "Mind Flicker", ghost: "Shade Slash",
      dragon: "Draco Pulse", ice: "Frost Chip", fighting: "Power Jab",
    };
    if (typed[t] && Math.random() < 0.55) return typed[t];
    return MOVE_FLAVOR[Math.floor(Math.random() * MOVE_FLAVOR.length)];
  }

  function resolvePartner(roster, map) {
    const pref = loadPartner();
    const byId = {};
    (roster || []).forEach((p) => { if (p && p.id) byId[p.id] = p; });
    if (pref && byId[pref.id] && unlockedFor(map, pref.id).length) {
      const poke = byId[pref.id];
      let vk = pref.versionKey;
      if (!vk || unlockedFor(map, pref.id).indexOf(vk) === -1) {
        vk = displayKeyFor(poke, map) || unlockedFor(map, pref.id)[0];
      }
      return { poke: poke, versionKey: vk };
    }
    // Fallback: first caught
    for (let i = 0; i < (roster || []).length; i++) {
      const p = roster[i];
      if (unlockedFor(map, p.id).length) {
        return { poke: p, versionKey: displayKeyFor(p, map) || unlockedFor(map, p.id)[0] };
      }
    }
    return null;
  }

  function setPartnerFromPoke(p, map) {
    const vk = displayKeyFor(p, map) || unlockedFor(map, p.id)[0];
    savePartner({ id: p.id, versionKey: vk });
    document.querySelectorAll(".goadedex-cell.is-partner").forEach((el) => el.classList.remove("is-partner"));
    const cells = document.querySelectorAll(".goadedex-cell[data-poke-id]");
    cells.forEach((el) => {
      if (el.getAttribute("data-poke-id") === p.id) el.classList.add("is-partner");
    });
    refreshPartnerChip(p);
    const toast = ensureToast();
    toast.innerHTML = "Fight partner: <strong>" + p.name + "</strong>";
    toast.classList.remove("is-shiny", "is-flee");
    toast.classList.add("is-on");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toast.classList.remove("is-on"), 2200);
  }

  function refreshPartnerChip(poke) {
    const emptyEl = document.querySelector("[data-partner-empty]");
    const setEl = document.querySelector("[data-partner-set]");
    let chip = document.querySelector("[data-partner-chip]");
    if (!poke) {
      if (emptyEl) emptyEl.hidden = false;
      if (setEl) setEl.hidden = true;
      if (chip) {
        chip.hidden = true;
        chip.textContent = "";
      }
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (setEl) setEl.hidden = false;
    if (chip) {
      chip.hidden = false;
      chip.textContent = poke.name;
    }
  }

  function renderBadgeCase(meta) {
    let caseEl = document.querySelector("[data-badge-case]");
    if (!caseEl) {
      const chips = document.querySelector(".goatedex-meta-chips");
      if (!chips) return;
      caseEl = document.createElement("div");
      caseEl.className = "goatedex-badge-case";
      caseEl.setAttribute("data-badge-case", "");
      caseEl.setAttribute("role", "list");
      caseEl.setAttribute("aria-label", "Gym badge case");
      chips.appendChild(caseEl);
    }
    const earned = Math.max(0, meta.count || 0);
    const slots = GYM_BADGES.length;
    let html = "";
    for (let i = 0; i < slots; i++) {
      const def = GYM_BADGES[i];
      // count=0 → next is always Boulder (never Grass/GRS type chrome)
      const lit = i < earned;
      const next = i === earned;
      const shortLabel = def.id === "boulder" ? "BOU" : def.short;
      const title = lit
        ? def.name + " Badge"
        : next
          ? "Next: " + def.name + " Badge"
          : def.name + " (locked)";
      html +=
        '<span class="goatedex-gym-badge' +
        (lit ? " is-earned" : " is-locked") +
        (next ? " is-next" : "") +
        (next && def.id === "boulder" ? " is-next-boulder" : "") +
        '" role="listitem" title="' +
        title +
        '" data-gym="' +
        def.id +
        '" style="--gym-color:' +
        def.color +
        '">' +
        gymBadgeImgHtml(def, "goatedex-gym-art") +
        '<span class="goatedex-gym-short">' +
        shortLabel +
        "</span></span>";
    }
    const overflow = Math.max(0, earned - slots);
    if (overflow > 0) {
      html +=
        '<span class="goatedex-gym-overflow" title="' +
        overflow +
        ' extra prestige' +
        (overflow === 1 ? "" : "s") +
        '" aria-label="' +
        overflow +
        ' star badges">★×' +
        overflow +
        "</span>";
    }
    caseEl.innerHTML = html;
    caseEl.dataset.count = String(earned);
    caseEl.hidden = false;
    caseEl.removeAttribute("hidden");
  }

  function refreshPrestigeUI(rosterLen) {
    const meta = loadPrestige();
    const badge = document.querySelector("[data-prestige-badge]");
    const stars = document.querySelector("[data-prestige-stars]");
    const btn = document.querySelector("[data-prestige-btn]");
    const hardBtn = document.querySelector("[data-hard-reset-btn]");
    const map = loadCaughtMap();
    const caught = speciesCaughtCount(map);
    const complete = rosterLen > 0 && caught >= rosterLen;
    const earned = meta.count > 0;
    renderBadgeCase(meta);
    if (badge) {
      // Compact latest-badge chip (badge case is primary)
      if (earned) {
        badge.hidden = false;
        badge.classList.remove("is-locked");
        badge.removeAttribute("hidden");
        const latestDef = gymBadgeDef(Math.max(0, meta.count - 1));
        const label = prestigeBadgeLabel(meta);
        if (latestDef && !latestDef.overflow && gymBadgeImgUrl(latestDef)) {
          badge.innerHTML =
            gymBadgeImgHtml(latestDef, "goatedex-prestige-badge-art") +
            '<span class="goatedex-prestige-badge-label">' +
            label +
            "</span>";
        } else {
          badge.textContent = label;
        }
        badge.title = prestigeTierName(meta.count) + " · Gym rank " + meta.count;
        badge.dataset.tier = String(Math.min(meta.count, 8));
        badge.setAttribute("aria-hidden", "false");
      } else {
        badge.hidden = true;
        badge.setAttribute("hidden", "");
        badge.classList.add("is-locked");
        badge.textContent = "";
        badge.innerHTML = "";
        badge.removeAttribute("data-tier");
        badge.title = "Prestige";
        badge.setAttribute("aria-hidden", "true");
      }
    }
    if (stars) {
      const overflow = Math.max(0, (meta.count || 0) - GYM_BADGES.length);
      if (overflow > 0) {
        stars.hidden = false;
        stars.classList.remove("is-locked");
        stars.removeAttribute("hidden");
        stars.textContent = "★×" + overflow;
        stars.title = overflow + " star badge" + (overflow === 1 ? "" : "s") + " beyond the Indigo 8";
      } else {
        stars.hidden = true;
        stars.setAttribute("hidden", "");
        stars.classList.add("is-locked");
        stars.textContent = "";
      }
    }
    if (btn) {
      // Same gate as full-species clear — never show early
      btn.hidden = !complete;
      btn.disabled = !complete;
      if (complete) {
        btn.classList.remove("is-locked");
        btn.removeAttribute("hidden");
        btn.setAttribute("aria-hidden", "false");
      } else {
        btn.setAttribute("hidden", "");
        btn.classList.add("is-locked");
        btn.setAttribute("aria-hidden", "true");
      }
    }
    if (hardBtn) {
      hardBtn.hidden = caught === 0;
      if (caught === 0) hardBtn.setAttribute("hidden", "");
      else hardBtn.removeAttribute("hidden");
    }
    const acct = document.querySelector("[data-account-chip]");
    if (acct) {
      acct.hidden = false;
      acct.textContent = cfg.customerId ? "Account" : "Guest";
      acct.classList.toggle("is-guest", !cfg.customerId);
    }
  }

  function runPrestigeCeremony(tierName, count, badgeInfo) {
    let layer = document.querySelector(".goaded-prestige-ceremony");
    if (!layer) {
      layer = document.createElement("div");
      layer.className = "goaded-prestige-ceremony";
      layer.setAttribute("aria-live", "assertive");
      layer.setAttribute("role", "dialog");
      layer.setAttribute("aria-label", "Prestige unlocked");
      document.body.appendChild(layer);
    }
    const dismiss = () => {
      clearTimeout(runPrestigeCeremony._t);
      layer.classList.add("is-out");
      setTimeout(() => {
        layer.classList.remove("is-on", "is-out");
        layer.innerHTML = "";
        layer.onclick = null;
      }, 340);
    };
    const info = badgeInfo || gymBadgeDef(Math.max(0, count - 1)) || { name: tierName, glyph: "★", color: "#ffe56a", short: "★" };
    const color = info.color || "#ffe56a";
    const artHtml = gymBadgeImgHtml(info, "goaded-prestige-badge-art");
    layer.innerHTML =
      '<div class="goaded-prestige-card">' +
      '<div class="goaded-prestige-burst" aria-hidden="true"></div>' +
      '<div class="goaded-prestige-title">GYM BADGE</div>' +
      '<div class="goaded-prestige-badge-flash" style="--gym-color:' + color + '">' +
      artHtml +
      '<span class="goaded-prestige-badge-name">' + (info.name || tierName) + '</span>' +
      "</div>" +
      '<div class="goaded-prestige-tier">' + (info.name || tierName) + " Badge</div>" +
      '<div class="goaded-prestige-sub">Badge #' + count + " unlocked · Gym rank " + count + " · Dex reset — hunt again</div>" +
      '<div class="goaded-prestige-hint">Tap anywhere to dismiss</div>' +
      "</div>";
    layer.classList.remove("is-out");
    layer.classList.add("is-on");
    layer.onclick = dismiss;
    clearTimeout(runPrestigeCeremony._t);
    runPrestigeCeremony._t = setTimeout(dismiss, 4800);
  }

  function confirmPrestige(roster) {
    const map = loadCaughtMap();
    const max = (roster || []).length;
    if (!max || speciesCaughtCount(map) < max) {
      window.alert("Catch every species first, then Prestige for a badge.");
      return;
    }
    const ok = window.confirm(
      "PRESTIGE clears ALL catches and awards a badge.\n\n" +
        "Your prestige count & badges stay. Art prefs stay.\n\n" +
        "This cannot be undone. Prestige now?"
    );
    if (!ok) return;
    const ok2 = window.confirm("Final confirm: wipe the Goatédex and earn a prestige badge?");
    if (!ok2) return;
    const meta = loadPrestige();
    meta.count = (meta.count || 0) + 1;
    const def = gymBadgeDef(meta.count - 1);
    const badgeEntry = {
      id: def.id,
      name: def.name,
      short: def.short,
      color: def.color,
      glyph: def.glyph,
      at: Date.now(),
      overflow: !!def.overflow,
    };
    meta.badges = synthesizeBadges(meta.count - 1, meta.badges);
    meta.badges.push(badgeEntry);
    savePrestige(meta);
    bumpDexEpoch();
    saveCaughtMap({});
    savePartner(null);
    const tier = prestigeTierName(meta.count);
    refreshChip(0, max);
    refreshPrestigeUI(max); // sync latest chip to NEW badge as ceremony opens
    runPrestigeCeremony(tier, meta.count, badgeEntry);
    renderDexGrid(roster);
    showToast("Prestige!", 0, max, false);
  }

  function confirmHardReset(roster) {
    const map = loadCaughtMap();
    if (!speciesCaughtCount(map)) return;
    const ok = window.confirm(
      "HARD RESET clears ALL catches with NO badge.\n\n" +
        "Prestige badges are kept. This cannot be undone.\n\nContinue?"
    );
    if (!ok) return;
    const phrase = window.prompt('Type RESET (all caps) to confirm hard wipe:');
    if (phrase !== "RESET") {
      window.alert("Hard reset cancelled.");
      return;
    }
    bumpDexEpoch();
    saveCaughtMap({});
    savePartner(null);
    const max = (roster || []).length;
    refreshChip(0, max);
    refreshPrestigeUI(max);
    renderDexGrid(roster);
    const toast = ensureToast();
    toast.innerHTML = "Hard reset — progress wiped (no badge).";
    toast.classList.remove("is-shiny");
    toast.classList.add("is-on", "is-flee");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toast.classList.remove("is-on", "is-flee"), 3200);
  }
  function unlockedFor(map, id) {
    const list = map[id];
    return Array.isArray(list) ? list.slice() : [];
  }
  function speciesCaughtCount(map) {
    return Object.keys(map).filter((id) => (map[id] || []).length > 0).length;
  }
  function unlockVersion(map, pokeOrId, versionKey) {
    const poke = typeof pokeOrId === "object" && pokeOrId ? pokeOrId : { id: pokeOrId, num: Number(String(pokeOrId).replace(/^poke-/, "")) || 0, sprite: "" };
    const pokeId = poke.id;
    const key = coerceVersionKey(poke, versionKey);
    const list = unlockedFor(map, pokeId);
    if (list.indexOf(key) === -1) list.push(key);
    map[pokeId] = list;
    saveCaughtMap(map);
    return map;
  }
  function missingKeys(p, map) {
    const have = new Set(unlockedFor(map, p.id).map((k) => coerceVersionKey(p, k)));
    return availableKeysSync(p).filter((k) => !have.has(k));
  }
  function isIncomplete(p, map) {
    return missingKeys(p, map).length > 0;
  }
  function missingShinyKeys(p, map) {
    if (!isIcon(p)) return [];
    const have = new Set(unlockedFor(map, p.id).map((k) => coerceVersionKey(p, k)));
    return SHINY_KEYS.filter((k) => !have.has(k) && likelyAvailable(p, k));
  }
  function preferredShinyKey(missing) {
    for (let i = 0; i < SHINY_SPAWN_PREF.length; i++) {
      if (missing.indexOf(SHINY_SPAWN_PREF[i]) !== -1) return SHINY_SPAWN_PREF[i];
    }
    return missing[0] || null;
  }
  function isShinyKey(key) {
    return !!VERSION_META[key] && VERSION_META[key].shiny;
  }
  function displayKeyFor(p, map) {
    const prefs = loadArtPrefs();
    const unlocked = unlockedFor(map, p.id).map((k) => coerceVersionKey(p, k));
    // dedupe
    const seen = {};
    const list = [];
    unlocked.forEach((k) => {
      if (!seen[k]) {
        seen[k] = true;
        list.push(k);
      }
    });
    if (!list.length) return null;
    const pref = prefs[p.id] ? coerceVersionKey(p, prefs[p.id]) : null;
    if (pref && list.indexOf(pref) !== -1) return pref;
    if (list.indexOf("gen3") !== -1) return "gen3";
    const nonShiny = list.filter((k) => !isShinyKey(k));
    if (nonShiny.length) return nonShiny[0];
    return list[0];
  }

  function shuffle(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  }

  let dexPromise = null;
  function loadDex() {
    if (dexPromise) return dexPromise;
    const rosterP = cfg.rosterUrl
      ? fetch(cfg.rosterUrl)
          .then((r) => r.json())
          .then((data) => (Array.isArray(data) ? data : []))
          .catch(() => [])
      : Promise.resolve([]);
    dexPromise = rosterP.then((roster) => ({ roster: roster, all: roster }));
    return dexPromise;
  }

  function spriteUrlFallback(p) {
    if (p.sprite) return p.sprite;
    return BASE + "/" + p.num + ".png";
  }

  function ensureToast() {
    let el = document.querySelector(".goaded-catch-toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "goaded-catch-toast";
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");
      document.body.appendChild(el);
    }
    return el;
  }
  function showToast(name, speciesCount, max, isShiny) {
    const toast = ensureToast();
    toast.innerHTML = isShiny
      ? "✦ SHINY <strong>" + name + "</strong>! · " + speciesCount + "/" + max
      : "You caught <strong>" + name + "</strong>! · " + speciesCount + "/" + max;
    toast.classList.toggle("is-shiny", !!isShiny);
    toast.classList.remove("is-flee");
    toast.classList.add("is-on");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toast.classList.remove("is-on", "is-shiny", "is-flee"), 3200);
  }
  function showFleeToast(name) {
    const toast = ensureToast();
    toast.innerHTML = "<strong>" + name + "</strong> got away!";
    toast.classList.remove("is-shiny");
    toast.classList.add("is-on", "is-flee");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toast.classList.remove("is-on", "is-flee"), 2800);
  }

  function celebrateShiny(poke) {
    maybeFirstShinyToday(poke);
    let layer = document.querySelector(".goaded-shiny-celebrate");
    if (!layer) {
      layer = document.createElement("div");
      layer.className = "goaded-shiny-celebrate";
      layer.setAttribute("aria-live", "assertive");
      document.body.appendChild(layer);
    }
    layer.innerHTML = "";
    layer.classList.add("is-on");

    const sparks = document.createElement("div");
    sparks.className = "goaded-shiny-sparks";
    for (let i = 0; i < 28; i++) {
      const s = document.createElement("span");
      s.style.setProperty("--i", String(i));
      s.style.setProperty("--r", (Math.random() * 360).toFixed(1) + "deg");
      s.style.setProperty("--d", (0.4 + Math.random() * 0.9).toFixed(2) + "s");
      s.style.setProperty("--x", (40 + Math.random() * 60).toFixed(1) + "vw");
      sparks.appendChild(s);
    }
    layer.appendChild(sparks);

    const hit = document.createElement("div");
    hit.className = "goaded-shiny-hit";
    hit.innerHTML =
      '<div class="goaded-shiny-hit-title">✦ SHINY ✦</div>' +
      '<div class="goaded-shiny-hit-name">' +
      poke.name +
      "</div>";
    layer.appendChild(hit);

    clearTimeout(celebrateShiny._t);
    celebrateShiny._t = setTimeout(() => {
      layer.classList.remove("is-on");
      layer.innerHTML = "";
    }, 2800);
  }

  function refreshChip(speciesCount, max) {
    let chip = document.querySelector(".goadedex-chip");
    if (!chip) {
      chip = document.createElement("a");
      chip.className = "goadedex-chip";
      chip.href = "/pages/goatedex";
      chip.innerHTML =
        'Goatédex <strong data-count>0</strong>/<span data-max>' + max + "</span>";
      document.body.appendChild(chip);
    }
    const countEl = chip.querySelector("[data-count]");
    const maxEl = chip.querySelector("[data-max]");
    if (countEl) countEl.textContent = String(speciesCount);
    if (maxEl) maxEl.textContent = String(max);
    chip.classList.toggle("is-on", speciesCount > 0);
  }

  function forbiddenRects() {
    const sel = [
      ".product-card",
      ".spotlight-media",
      ".site-header",
      ".live-bar",
      ".footer",
      ".site-footer",
      "footer",
      ".goadedex-chip",
      ".goaded-streak-field",
      ".goatedex-streak-chip",
      ".goaded-catch-toast",
      ".account-panel",
      ".goatedex-panel",
      ".goatedex-progress",
      "[data-goatedex-progress]",
      ".goatedex-head",
      ".goadedex-grid",
      ".goatedex-page",
      ".goatedex-section",
      ".goatedex-banner",
      ".goatedex-banner-top",
      ".hero",
      ".hero-grid",
      ".hero h1",
      ".hero .lede",
      ".hero-ctas",
      ".page-banner",
      ".page-banner h1",
      ".page-banner .sub",
      "input",
      "textarea",
      "select",
    ].join(",");
    const scrollY = window.scrollY || window.pageYOffset;
    const scrollX = window.scrollX || window.pageXOffset;
    return Array.from(document.querySelectorAll(sel)).map((el) => {
      const r = el.getBoundingClientRect();
      const isHero = el.matches && (
        el.matches(".hero") ||
        el.matches(".hero-grid") ||
        el.matches(".page-banner") ||
        el.matches(".goatedex-banner") ||
        el.closest(".hero") ||
        el.closest(".goatedex-banner") ||
        el.closest(".page-banner")
      );
      const isDexChrome = el.matches && (
        el.matches(".goatedex-section") ||
        el.matches(".goatedex-page") ||
        el.matches(".goatedex-panel") ||
        el.matches(".account-panel") ||
        el.matches(".goatedex-head") ||
        el.matches(".goatedex-progress") ||
        el.matches("[data-goatedex-progress]") ||
        el.closest(".goatedex-section") ||
        el.closest(".goatedex-panel")
      );
      // Large pad so field critters never sit under GOATÉDEX title / banner / dex chrome / panel / progress
      const isPanelish = el.matches && (
        el.matches(".goatedex-panel") ||
        el.matches(".goatedex-progress") ||
        el.matches("[data-goatedex-progress]") ||
        el.closest(".goatedex-panel")
      );
      const pad = isHero ? 120 : (isPanelish ? 96 : (isDexChrome ? 56 : 8));
      return {
        left: r.left + scrollX - pad,
        top: r.top + scrollY - pad,
        right: r.right + scrollX + pad,
        bottom: r.bottom + scrollY + pad,
      };
    });
  }

  function overlaps(a, b) {
    return !(a.right < b.left || a.left > b.right || a.bottom < b.top || a.top > b.bottom);
  }

  function ensureField() {
    let field = document.getElementById("goadedex-field");
    if (!field) {
      field = document.createElement("div");
      field.id = "goadedex-field";
      document.body.appendChild(field);
    }
    const docH = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      window.innerHeight
    );
    field.style.height = docH + "px";
    return field;
  }

  /** Max pixel footprint after scale — used so placement never assumes the tiny default box. */
  const SPAWN_SIZE = 200;

  function visibleSpawnBounds(size) {
    const pad = 12;
    const vw = document.documentElement.clientWidth;
    const vh = window.innerHeight;
    const scrollX = window.pageXOffset || 0;
    const scrollY = window.pageYOffset || 0;
    const minX = scrollX + pad;
    const maxX = scrollX + vw - size - pad;
    // On Goatédex page, push spawns below banner+head so sprites never sit under title
    const onDex = !!document.querySelector("[data-goatedex-grid], .goatedex-banner");
    const headClear = onDex ? Math.min(vh * 0.55, 360) : 110;
    const minY = scrollY + headClear;
    const maxY = scrollY + vh - size - pad - 72;
    return {
      minX: minX,
      maxX: Math.max(minX, maxX),
      minY: minY,
      maxY: Math.max(minY, maxY),
      vw: vw,
      vh: vh,
      scrollX: scrollX,
      scrollY: scrollY,
    };
  }

  function clampSpawnInView(btn) {
    if (!btn || !btn.isConnected) return;
    const w = btn.offsetWidth || SPAWN_SIZE;
    const h = btn.offsetHeight || SPAWN_SIZE;
    const b = visibleSpawnBounds(Math.max(w, h));
    let x = parseFloat(btn.style.left);
    let y = parseFloat(btn.style.top);
    if (!isFinite(x)) x = b.minX;
    if (!isFinite(y)) y = b.minY;
    // Horizontal: always fully on-screen
    x = Math.min(Math.max(x, b.minX), b.maxX);
    // Vertical: prefer current viewport; if page is short, still clamp
    const size = Math.max(w, h);
    const vb = visibleSpawnBounds(size);
    y = Math.min(Math.max(y, vb.minY), vb.maxY);
    btn.style.left = Math.round(x) + "px";
    btn.style.top = Math.round(y) + "px";
  }

  function pickEmptySpots(count) {
    const forbid = forbiddenRects();
    const size = SPAWN_SIZE;
    const spots = [];
    const b = visibleSpawnBounds(size);
    const gutter = Math.min(88, Math.max(40, b.vw * 0.1));
    const spanX = Math.max(8, b.maxX - b.minX);
    const spanY = Math.max(8, b.maxY - b.minY);

    for (let attempt = 0; attempt < 320 && spots.length < count; attempt++) {
      let x, y;
      const lane = attempt % 4;
      if (lane === 0) {
        // Left gutter — keep fully inside
        x = b.minX + Math.random() * Math.min(gutter, spanX * 0.35);
        y = b.minY + Math.random() * spanY;
      } else if (lane === 1) {
        // Right gutter — subtract full size so scaled sprites don't clip
        x = b.maxX - Math.random() * Math.min(gutter, spanX * 0.35);
        y = b.minY + Math.random() * spanY;
      } else if (lane === 2) {
        x = b.minX + gutter + Math.random() * Math.max(8, spanX - gutter * 2);
        y = b.minY + Math.random() * spanY;
      } else {
        x = b.minX + Math.random() * spanX;
        y = b.maxY - Math.random() * Math.min(100, spanY * 0.4);
      }
      x = Math.min(Math.max(x, b.minX), b.maxX);
      y = Math.min(Math.max(y, b.minY), b.maxY);
      const rect = { left: x, top: y, right: x + size, bottom: y + size };
      if (forbid.some((f) => overlaps(rect, f))) continue;
      if (
        spots.some((s) =>
          overlaps(rect, {
            left: s.x - 16,
            top: s.y - 16,
            right: s.x + size + 16,
            bottom: s.y + size + 16,
          })
        )
      )
        continue;
      spots.push({ x: x, y: y });
    }
    if (!spots.length) {
      // Prefer side gutters; never fall back into the dex panel / progress chrome
      const candidates = [
        { x: b.minX, y: b.minY + spanY * 0.55 },
        { x: b.maxX, y: b.minY + spanY * 0.55 },
        { x: b.minX, y: b.maxY },
        { x: b.maxX, y: b.maxY },
        { x: b.minX + spanX * 0.15, y: b.maxY },
        { x: b.minX + spanX * 0.85, y: b.maxY },
      ];
      for (let i = 0; i < candidates.length; i++) {
        const c = candidates[i];
        const rect = { left: c.x, top: c.y, right: c.x + size, bottom: c.y + size };
        if (!forbid.some((f) => overlaps(rect, f))) {
          spots.push(c);
          break;
        }
      }
      // Absolute last resort: left gutter below fold — still better than covering progress
      if (!spots.length) spots.push({ x: b.minX, y: Math.max(b.minY, b.maxY) });
    }
    return spots;
  }

  function applyPixelScale(img, btn) {
    const fit = () => {
      const nw = img.naturalWidth || 64;
      const nh = img.naturalHeight || 64;
      const maxSide = Math.max(nw, nh);
      let s = Math.floor(160 / maxSide);
      if (s < 3) s = 3;
      if (s > 5) s = 5;
      if (maxSide <= 64 && s < 4) s = 4;
      // Cap so a fat sprite cannot exceed the spawn budget / viewport
      const maxPx = Math.min(SPAWN_SIZE, Math.floor(document.documentElement.clientWidth * 0.42));
      let w = nw * s;
      let h = nh * s;
      if (w > maxPx || h > maxPx) {
        const scale = maxPx / Math.max(w, h);
        w = Math.max(1, Math.floor(w * scale));
        h = Math.max(1, Math.floor(h * scale));
      }
      btn.style.width = w + "px";
      btn.style.height = h + "px";
      img.width = w;
      img.height = h;
      img.style.width = w + "px";
      img.style.height = h + "px";
      img.style.transform = "";
      img.style.imageRendering = "pixelated";
      clampSpawnInView(btn);
    };
    if (img.complete && img.naturalWidth) fit();
    else img.addEventListener("load", fit, { once: true });
  }

  /**
   * Shiny forced-spawn multiplier from catch streak.
   * Base rate stays 1/64; effective = base × (1 + min(0.35, streak × 0.035)).
   * Soft-caps at +35% relative (~1.35×) from streak 10 onward.
   */
  function shinyStreakMultiplier(streak) {
    const s = Math.max(0, Number(streak) || 0);
    return 1 + Math.min(0.35, s * 0.035);
  }

  function shinySpawnChance(streak) {
    return (1 / 64) * shinyStreakMultiplier(streak);
  }

  function pickSpawnTarget(roster, map) {
    const incomplete = roster.filter((p) => isIncomplete(p, map));
    const pool = incomplete.length ? incomplete : roster;

    // Base 1/64 shiny force-spawn, lightly boosted by catch streak (see shinySpawnChance)
    if (Math.random() < shinySpawnChance(loadStreak())) {
      const icons = shuffle(
        roster.filter((p) => {
          return missingShinyKeys(p, map).length > 0;
        })
      );
      if (icons.length) {
        const poke = icons[0];
        const shinyMissing = missingShinyKeys(poke, map);
        const key = preferredShinyKey(shinyMissing);
        if (key) return { poke: poke, versionKey: key, isShiny: true };
      }
    }

    const poke = pool[Math.floor(Math.random() * pool.length)];
    const missing = missingKeys(poke, map);
    let versionKey;
    if (missing.length) {
      versionKey = missing[Math.floor(Math.random() * missing.length)];
    } else {
      const avail = availableKeysSync(poke);
      versionKey = avail[Math.floor(Math.random() * avail.length)] || "default";
    }
    return { poke: poke, versionKey: versionKey, isShiny: isShinyKey(versionKey) };
  }



  /** Lab: majority of encounters battle so soft-flee / timing can be smoked (~3 in 4). */
  function shouldBattle(poke, shiny) {
    let chance = 0.72;
    if (shiny) chance = 0.88;
    else if (isIcon(poke)) chance = 0.8;
    return Math.random() < chance;
  }

  function setBattlePrivacyChrome(open) {
    const nodes = document.querySelectorAll(
      '#shopify-pc__banner, #shopify-pc__prefs, .shopify-pc-banner, .shopify-cleanslate, [id^="shopify-pc"]'
    );
    nodes.forEach((el) => {
      if (open) {
        if (!el.dataset.goadedPrevVis) el.dataset.goadedPrevVis = el.style.visibility || '';
        if (!el.dataset.goadedPrevPe) el.dataset.goadedPrevPe = el.style.pointerEvents || '';
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.style.removeProperty('visibility');
        el.style.removeProperty('pointer-events');
        el.style.removeProperty('opacity');
        if (el.dataset.goadedPrevVis !== undefined) {
          el.style.visibility = el.dataset.goadedPrevVis;
          delete el.dataset.goadedPrevVis;
        }
        if (el.dataset.goadedPrevPe !== undefined) {
          el.style.pointerEvents = el.dataset.goadedPrevPe;
          delete el.dataset.goadedPrevPe;
        }
        el.removeAttribute('aria-hidden');
      }
    });
  }

  function ensureBattleModal() {
    let el = document.querySelector(".goaded-battle");
    // Rebuild if Lab v5 chrome missing (hits HUD / party pips)
    if (el && !el.querySelector("[data-battle-hits]")) {
      el.remove();
      el = null;
    }
    if (el) return el;
    el = document.createElement("div");
    el.className = "goaded-battle";
    el.hidden = true;
    el.innerHTML =
      '<div class="goaded-battle-panel" role="dialog" aria-modal="true" aria-label="Wild battle">' +
      '<button type="button" class="goaded-battle-x" data-battle-flee title="Run (Esc)" aria-label="Run">×</button>' +
      '<div class="goaded-battle-sky" data-battle-arena>' +
      '<div class="goaded-battle-arena-fx" aria-hidden="true"></div>' +
      '<div class="goaded-battle-stage">' +
      '<div class="goaded-battle-side is-partner" data-side-partner>' +
      '<div class="goaded-battle-plate">' +
      '<div class="goaded-battle-plate-top"><div class="goaded-battle-plate-name" data-partner-name>—</div><span class="goaded-battle-type-pill" data-partner-type></span></div>' +
      '<div class="goaded-battle-hp"><span class="goaded-battle-hp-fill" data-partner-hp-fill></span></div>' +
      '</div>' +
      '<div class="goaded-battle-mon-wrap is-partner"><img class="goaded-battle-partner" alt="" /></div>' +
      '<div class="goaded-battle-side-tag">YOU</div>' +
      '</div>' +
      '<div class="goaded-battle-vs" aria-hidden="true">VS</div>' +
      '<div class="goaded-battle-side is-wild" data-side-wild>' +
      '<div class="goaded-battle-plate">' +
      '<div class="goaded-battle-plate-top"><div class="goaded-battle-plate-name" data-wild-name>—</div><span class="goaded-battle-type-pill" data-wild-type></span></div>' +
      '<div class="goaded-battle-hp"><span class="goaded-battle-hp-fill" data-wild-hp-fill></span></div>' +
      '</div>' +
      '<div class="goaded-battle-mon-wrap is-wild"><img class="goaded-battle-mon" alt="" /></div>' +
      '<div class="goaded-battle-side-tag is-wild-tag" data-wild-tag>WILD</div>' +
      '</div>' +
      '</div>' +
      '<div class="goaded-battle-move" data-battle-move hidden></div>' +
      '<div class="goaded-battle-fx" data-battle-fx aria-hidden="true"></div>' +
      '<div class="goaded-battle-banner" data-battle-banner>A wild <strong data-battle-name></strong> appeared!</div>' +
      '</div>' +
      '<div class="goaded-battle-hud">' +
      '<div class="goaded-battle-party" data-battle-party hidden aria-label="Trainer party"></div>' +
      '<div class="goaded-battle-gym-rank" data-gym-rank hidden></div>' +
      '<div class="goaded-battle-hits" data-battle-hits hidden></div>' +
      '<p class="goaded-battle-hint">Tap <strong>FIGHT</strong> when the marker hits the green zone · each green hit chips HP · <kbd>Esc</kbd> / × to RUN</p>' +
      '<div class="goaded-battle-bar" aria-hidden="true">' +
      '<div class="goaded-battle-zone"></div>' +
      '<div class="goaded-battle-marker"></div>' +
      '</div>' +
      '<div class="goaded-battle-actions">' +
      '<button type="button" class="btn btn-primary goaded-battle-fight" data-battle-fight>FIGHT</button>' +
      '<button type="button" class="btn btn-ghost goaded-battle-run" data-battle-flee>RUN</button>' +
      '</div>' +
      '<p class="goaded-battle-result" data-battle-result hidden></p>' +
      '</div></div>';
    document.body.appendChild(el);
    return el;
  }

  function spawnBattleParticles(fxRoot, kind) {
    if (!fxRoot) return;
    const n = kind === "crit" ? 14 : kind === "hit" ? 10 : 6;
    for (let i = 0; i < n; i++) {
      const s = document.createElement("span");
      s.className = "goaded-battle-spark is-" + kind;
      s.style.setProperty("--a", (Math.random() * 360).toFixed(1) + "deg");
      s.style.setProperty("--d", (20 + Math.random() * 48).toFixed(1) + "px");
      s.style.left = (40 + Math.random() * 20) + "%";
      s.style.top = (35 + Math.random() * 30) + "%";
      fxRoot.appendChild(s);
      setTimeout(() => s.remove(), 700);
    }
  }

  /**
   * Timing-bar mini battle. Partner LEFT / wild RIGHT.
   * Resolves true (win) / false (flee). Soft flee via × / RUN / Esc / tap-outside — no confirm.
   */
  /**
   * Timing-bar multi-hit battle. Partner LEFT / wild RIGHT.
   * Each green-zone FIGHT chips real HP; win only at 0. Miss = no HP drop (keep fighting).
   * Soft flee via × / RUN / Esc / tap-outside — no confirm.
   * opts: { trainer, trainerName, partyIndex, partySize, keepOpen, introBanner }
   */
  function runBattleMinigame(poke, versionKey, shiny, roster, opts) {
    opts = opts || {};
    return new Promise((resolve) => {
      const modal = ensureBattleModal();
      const arena = modal.querySelector("[data-battle-arena]");
      const monImg = modal.querySelector(".goaded-battle-mon");
      const partnerImg = modal.querySelector(".goaded-battle-partner");
      const nameEl = modal.querySelector("[data-battle-name]");
      const wildName = modal.querySelector("[data-wild-name]");
      const partnerName = modal.querySelector("[data-partner-name]");
      const marker = modal.querySelector(".goaded-battle-marker");
      const zone = modal.querySelector(".goaded-battle-zone");
      const fightBtn = modal.querySelector("[data-battle-fight]");
      const resultEl = modal.querySelector("[data-battle-result]");
      const hint = modal.querySelector(".goaded-battle-hint");
      const moveEl = modal.querySelector("[data-battle-move]");
      const fxRoot = modal.querySelector("[data-battle-fx]");
      const wildHp = modal.querySelector("[data-wild-hp-fill]");
      const partnerHp = modal.querySelector("[data-partner-hp-fill]");
      const partnerSide = modal.querySelector("[data-side-partner]");
      const wildTag = modal.querySelector("[data-wild-tag]");
      const partyEl = modal.querySelector("[data-battle-party]");
      const hitsEl = modal.querySelector("[data-battle-hits]");
      const barEl = modal.querySelector(".goaded-battle-bar");
      const bannerEl = modal.querySelector("[data-battle-banner]") || modal.querySelector(".goaded-battle-banner");

      const map = loadCaughtMap();
      const partner = resolvePartner(roster, map);
      const tmeta = typeMeta(poke);
      const isNight = isNightHours();
      const isTrainer = !!opts.trainer;

      modal.className = "goaded-battle";
      modal.classList.toggle("is-shiny", !!shiny);
      modal.classList.toggle("is-night", isNight);
      modal.classList.toggle("has-partner", !!partner);
      modal.classList.toggle("is-trainer", isTrainer);
      if (arena) {
        arena.dataset.type = tmeta.key;
        arena.style.setProperty("--arena-hue", String(tmeta.hue));
        arena.style.setProperty("--arena-accent", tmeta.accent);
      }

      const wildTypeEl = modal.querySelector("[data-wild-type]");
      const partnerTypeEl = modal.querySelector("[data-partner-type]");
      if (bannerEl) {
        bannerEl.className = "goaded-battle-banner";
        if (opts.introBanner) {
          bannerEl.innerHTML = opts.introBanner;
        } else {
          bannerEl.innerHTML = 'A wild <strong data-battle-name></strong> appeared!';
          const bn = bannerEl.querySelector("[data-battle-name]");
          if (bn) bn.textContent = poke.name;
        }
      } else if (nameEl) {
        nameEl.textContent = poke.name;
      }
      if (wildName) wildName.textContent = (shiny ? "✦ " : "") + poke.name;
      if (wildTag) wildTag.textContent = isTrainer ? "TRAINER" : "WILD";
      if (wildTypeEl) {
        wildTypeEl.textContent = typePillLabel(tmeta.name);
        wildTypeEl.title = tmeta.name;
        wildTypeEl.style.background = tmeta.accent;
      }
      monImg.style.imageRendering = "pixelated";
      monImg.classList.remove("is-fleeing", "is-hit", "is-enter");
      monImg.src = versionUrl(poke.num, versionKey);
      monImg.onerror = () => {
        monImg.onerror = null;
        monImg.src = spriteUrlFallback(poke);
      };
      void monImg.offsetWidth;
      monImg.classList.add("is-enter");

      if (partner && partnerImg && partnerName) {
        partnerSide.hidden = false;
        partnerName.textContent = partner.poke.name;
        if (partnerTypeEl) {
          const pt = typeMeta(partner.poke);
          partnerTypeEl.textContent = typePillLabel(pt.name);
          partnerTypeEl.title = pt.name;
          partnerTypeEl.style.background = pt.accent;
        }
        partnerImg.style.imageRendering = "pixelated";
        partnerImg.classList.remove("is-hit", "is-enter", "is-flinch");
        partnerImg.src = versionUrl(partner.poke.num, partner.versionKey);
        partnerImg.onerror = () => {
          partnerImg.onerror = null;
          partnerImg.src = spriteUrlFallback(partner.poke);
        };
        void partnerImg.offsetWidth;
        partnerImg.classList.add("is-enter");
      } else if (partnerSide) {
        partnerSide.hidden = true;
      }

      const prestigeMeta = loadPrestige();
      const scale = battleScaleForPrestige(prestigeMeta.count || 0);
      const budget = wildHitBudget(poke, shiny, prestigeMeta.count || 0, { trainer: isTrainer });
      let hp = budget.maxHp;
      const maxHp = budget.maxHp;

      if (wildHp) {
        wildHp.classList.remove("is-low");
        wildHp.style.transition = "none";
        wildHp.style.width = "100%";
        void wildHp.offsetWidth;
        wildHp.style.transition = "";
      }
      if (partnerHp) partnerHp.style.width = (72 + Math.random() * 28) + "%";
      if (moveEl) { moveEl.hidden = true; moveEl.textContent = ""; }
      if (fxRoot) fxRoot.innerHTML = "";

      if (isTrainer && typeof opts.partySize === "number") {
        renderPartyPips(partyEl, opts.partySize, opts.partyIndex || 0);
      } else if (partyEl) {
        // Pure wild fights: never show trainer party pips
        partyEl.hidden = true;
        partyEl.setAttribute("hidden", "");
        partyEl.innerHTML = "";
        partyEl.removeAttribute("aria-label");
      }

      resultEl.hidden = true;
      resultEl.textContent = "";
      resultEl.setAttribute("hidden", "");
      fightBtn.disabled = false;
      modal.querySelectorAll("[data-battle-flee]").forEach((b) => {
        b.disabled = false;
        b.removeAttribute("aria-disabled");
      });
      modal.classList.remove("is-resolved", "is-win", "is-lose", "is-crit");
      hint.hidden = false;
      modal.hidden = false;
      setBattlePrivacyChrome(true);

      const gymRankEl = modal.querySelector("[data-gym-rank]");
      const updateHitsHud = () => {
        const hitsLeft = Math.max(0, Math.ceil(hp - 1e-6));
        const pct = Math.max(0, Math.round((hp / maxHp) * 100));
        if (hitsEl) {
          hitsEl.hidden = false;
          hitsEl.removeAttribute("hidden");
          hitsEl.textContent = hitsLeft + " hit" + (hitsLeft === 1 ? "" : "s") + " left · " + pct + "% HP";
          hitsEl.title =
            "Rarity " +
            budget.rarityHits +
            (budget.prestigeBonus ? " + prestige +" + budget.prestigeBonus : "") +
            (budget.trainerBonus ? " + trainer +" + budget.trainerBonus : "") +
            " (cap " +
            HIT_TOTAL_CAP +
            ")";
        }
        if (gymRankEl) {
          if (scale.rank > 0 || isTrainer) {
            gymRankEl.hidden = false;
            gymRankEl.removeAttribute("hidden");
            const bits = [];
            if (scale.rank > 0) bits.push("Gym rank " + scale.rank);
            if (isTrainer) bits.push("Trainer");
            bits.push(hitsLeft + " hit" + (hitsLeft === 1 ? "" : "s") + " left");
            gymRankEl.textContent = bits.join(" · ");
            gymRankEl.title = "Wild HP " + maxHp + " hits";
          } else {
            gymRankEl.hidden = true;
            gymRankEl.setAttribute("hidden", "");
            gymRankEl.textContent = "";
          }
        }
      };
      updateHitsHud();

      // Prestige shrinks zone + speeds marker; trainer = slightly tighter; shiny stacks on top
      const trainerTighten = isTrainer ? 1.2 : 0;
      const trainerSpeed = isTrainer ? 0.08 : 0;
      const baseZone = 14 + Math.random() * 6;
      const zoneW = Math.max(scale.zoneFloor, baseZone - scale.zoneShrink - trainerTighten);
      const zoneL = 18 + Math.random() * Math.max(8, 62 - zoneW);
      zone.style.width = zoneW + "%";
      zone.style.left = zoneL + "%";

      let pos = 0;
      let dir = 1;
      const baseSpeed = (shiny ? 1.55 : 1.25) + Math.random() * 0.35;
      const speed = baseSpeed + scale.speedBump + trainerSpeed;
      let raf = 0;
      let last = performance.now();
      let locked = false;
      let swingLock = false;

      const tick = (now) => {
        if (locked) return;
        const dt = Math.min(32, now - last);
        last = now;
        pos += dir * speed * dt * 0.12;
        if (pos >= 100) { pos = 100; dir = -1; }
        else if (pos <= 0) { pos = 0; dir = 1; }
        marker.style.left = pos + "%";
        raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);

      const cleanupListeners = () => {
        modal.removeEventListener("click", onBackdrop);
        document.removeEventListener("keydown", onKey);
        fightBtn.onclick = null;
        modal.querySelectorAll("[data-battle-flee]").forEach((b) => { b.onclick = null; });
      };

      const setBanner = (html, cls) => {
        if (!bannerEl) return;
        bannerEl.className = "goaded-battle-banner" + (cls ? " " + cls : "");
        bannerEl.innerHTML = html;
      };

      const setWildHpBar = (nextHp) => {
        if (!wildHp) return;
        const pct = Math.max(0, Math.min(100, (nextHp / maxHp) * 100));
        wildHp.style.width = pct + "%";
        wildHp.classList.toggle("is-low", pct <= 34);
      };

      const clearHitsHud = () => {
        if (hitsEl) {
          hitsEl.hidden = true;
          hitsEl.setAttribute("hidden", "");
          hitsEl.textContent = "";
          hitsEl.removeAttribute("title");
        }
        if (gymRankEl && !isTrainer && !(scale.rank > 0)) {
          gymRankEl.hidden = true;
          gymRankEl.setAttribute("hidden", "");
          gymRankEl.textContent = "";
        } else if (gymRankEl) {
          // Drop live hit countdown from gym line once resolved
          const bits = [];
          if (scale.rank > 0) bits.push("Gym rank " + scale.rank);
          if (isTrainer) bits.push("Trainer");
          if (bits.length) {
            gymRankEl.textContent = bits.join(" · ");
          } else {
            gymRankEl.hidden = true;
            gymRankEl.setAttribute("hidden", "");
            gymRankEl.textContent = "";
          }
        }
      };

      const lockResolvedChrome = () => {
        fightBtn.disabled = true;
        fightBtn.setAttribute("aria-disabled", "true");
        modal.querySelectorAll("[data-battle-flee]").forEach((b) => {
          b.disabled = true;
          b.setAttribute("aria-disabled", "true");
        });
        modal.classList.add("is-resolved");
        clearHitsHud();
        if (hint) hint.hidden = true;
        if (barEl) barEl.setAttribute("aria-hidden", "true");
      };

      const finish = (won, fledSoft, wasCrit) => {
        if (locked) return;
        locked = true;
        cancelAnimationFrame(raf);
        cleanupListeners();
        lockResolvedChrome();
        resultEl.hidden = true;
        resultEl.textContent = "";
        resultEl.setAttribute("hidden", "");
        if (won) {
          const move = pickMoveName(poke, shiny);
          if (moveEl) {
            moveEl.textContent = move + "!";
            moveEl.hidden = false;
            moveEl.classList.remove("is-on");
            void moveEl.offsetWidth;
            moveEl.classList.add("is-on");
          }
          if (partnerImg) partnerImg.classList.add("is-hit");
          monImg.classList.add("is-hit");
          spawnBattleParticles(fxRoot, wasCrit || shiny ? "crit" : "hit");
          if (wasCrit && barEl) {
            barEl.classList.add("is-crit-flash");
            modal.classList.add("is-crit");
          }
          setWildHpBar(0);
          // Final trainer clear gets a party banner; mid-party stays "Down!"
          if (isTrainer && !opts.keepOpen) {
            setBanner("Party defeated!", "is-win");
            if (partyEl && typeof opts.partySize === "number") {
              renderPartyPips(partyEl, opts.partySize, opts.partySize);
            }
          } else if (isTrainer) {
            setBanner("Down!", "is-win");
          } else {
            setBanner("Nice hit!", "is-win");
          }
          modal.classList.add("is-win");
        } else {
          const fleeMsg = fledSoft ? "Got away safely!" : (poke.name + " fled!");
          setBanner(fleeMsg, fledSoft ? "is-flee" : "is-lose");
          modal.classList.add("is-lose");
          monImg.classList.add("is-fleeing");
          spawnBattleParticles(fxRoot, "flee");
          // Leave HP bar at actual remaining % — never reset to 100% while resolved chrome shows
        }
        const linger = won
          ? (opts.keepOpen ? 620 : isTrainer ? 1200 : 900)
          : fledSoft
            ? 700
            : 820;
        setTimeout(() => {
          const midTrainer = !!(opts.keepOpen && won);
          if (!midTrainer) {
            modal.hidden = true;
            setBattlePrivacyChrome(false);
            modal.classList.remove("is-win", "is-lose", "is-shiny", "is-night", "has-partner", "is-crit", "is-resolved", "is-trainer");
            if (partyEl) {
              partyEl.hidden = true;
              partyEl.setAttribute("hidden", "");
              partyEl.innerHTML = "";
            }
            clearHitsHud();
            // Reset HP only after modal is fully closed — avoids depleted-bar vs 100% text mismatch
            if (wildHp) {
              wildHp.classList.remove("is-low");
              wildHp.style.width = "100%";
            }
            if (barEl) barEl.classList.remove("is-crit-flash");
            monImg.classList.remove("is-fleeing", "is-hit", "is-enter");
            if (partnerImg) partnerImg.classList.remove("is-hit", "is-enter", "is-flinch");
            if (moveEl) { moveEl.hidden = true; moveEl.classList.remove("is-on"); }
            // Keep controls disabled while closed; next openBattle re-enables
            fightBtn.disabled = true;
            fightBtn.setAttribute("aria-disabled", "true");
            modal.querySelectorAll("[data-battle-flee]").forEach((b) => {
              b.disabled = true;
              b.setAttribute("aria-disabled", "true");
            });
          } else {
            // Mid-party swap: clear resolve chrome then hand off to next fight open
            modal.classList.remove("is-win", "is-lose", "is-crit", "is-resolved");
            monImg.classList.remove("is-fleeing", "is-hit", "is-enter");
            if (partnerImg) partnerImg.classList.remove("is-hit", "is-enter", "is-flinch");
            if (moveEl) { moveEl.hidden = true; moveEl.classList.remove("is-on"); }
            if (wildHp) { wildHp.classList.remove("is-low"); wildHp.style.width = "100%"; }
            if (barEl) barEl.classList.remove("is-crit-flash");
            fightBtn.disabled = false;
            fightBtn.removeAttribute("aria-disabled");
            modal.querySelectorAll("[data-battle-flee]").forEach((b) => {
              b.disabled = false;
              b.removeAttribute("aria-disabled");
            });
          }
          resolve(won);
        }, linger);
      };

      const softFlee = () => {
        if (locked) return;
        finish(false, true);
      };

      const onBackdrop = (e) => {
        if (e.target === modal) softFlee();
      };
      const onKey = (e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          softFlee();
        }
      };
      modal.addEventListener("click", onBackdrop);
      document.addEventListener("keydown", onKey);
      modal.querySelectorAll("[data-battle-flee]").forEach((b) => {
        b.onclick = (e) => {
          e.stopPropagation();
          softFlee();
        };
      });

      fightBtn.onclick = () => {
        if (locked || swingLock) return;
        const hit = pos >= zoneL && pos <= zoneL + zoneW;
        const near = pos >= zoneL - 2 && pos <= zoneL + zoneW + 2;
        const zoneMid = zoneL + zoneW / 2;
        const wasCrit = hit && Math.abs(pos - zoneMid) <= Math.max(1.2, zoneW * 0.18);
        const connected = hit || (near && Math.random() < 0.35);

        if (!connected) {
          setBanner("Miss!", "is-miss");
          spawnBattleParticles(fxRoot, "flee");
          if (partnerImg) {
            partnerImg.classList.remove("is-flinch");
            void partnerImg.offsetWidth;
            partnerImg.classList.add("is-flinch");
            setTimeout(() => partnerImg.classList.remove("is-flinch"), 420);
          }
          if (partnerHp) {
            const cur = parseFloat(partnerHp.style.width) || 80;
            partnerHp.style.width = Math.max(28, cur - (8 + Math.random() * 10)) + "%";
          }
          swingLock = true;
          fightBtn.disabled = true;
          setTimeout(() => {
            if (locked) return;
            swingLock = false;
            fightBtn.disabled = false;
            if (bannerEl && !locked) {
              setBanner("Keep going — <strong>" + poke.name + "</strong> still stands!", "");
            }
          }, 380);
          return;
        }

        const chunk = wasCrit ? 1.5 : 1;
        hp = Math.max(0, hp - chunk);
        const move = pickMoveName(poke, shiny);
        if (moveEl) {
          moveEl.textContent = (wasCrit ? "CRIT! " : "") + move + "!";
          moveEl.hidden = false;
          moveEl.classList.remove("is-on");
          void moveEl.offsetWidth;
          moveEl.classList.add("is-on");
        }
        monImg.classList.remove("is-hit");
        void monImg.offsetWidth;
        monImg.classList.add("is-hit");
        if (partnerImg) {
          partnerImg.classList.remove("is-hit");
          void partnerImg.offsetWidth;
          partnerImg.classList.add("is-hit");
        }
        spawnBattleParticles(fxRoot, wasCrit || shiny ? "crit" : "hit");
        if (wasCrit && barEl) {
          barEl.classList.add("is-crit-flash");
          setTimeout(() => barEl.classList.remove("is-crit-flash"), 420);
        }
        setWildHpBar(hp);
        updateHitsHud();

        if (hp <= 0) {
          finish(true, false, wasCrit);
          return;
        }

        const hitsLeft = Math.max(0, Math.ceil(hp - 1e-6));
        setBanner(
          (wasCrit ? "Critical! " : "Hit! ") + hitsLeft + " hit" + (hitsLeft === 1 ? "" : "s") + " left",
          "is-chip"
        );
        swingLock = true;
        fightBtn.disabled = true;
        setTimeout(() => {
          if (locked) return;
          swingLock = false;
          fightBtn.disabled = false;
          monImg.classList.remove("is-hit");
          if (partnerImg) partnerImg.classList.remove("is-hit");
        }, 320);
      };
    });
  }


  /**
   * Soft Skip (deferred, not permanent): closes without granting a starter.
   * Next wild field click while speciesCaughtCount===0 can offer the picker again.
   * Esc / × match Skip — store-safe, never trap shoppers.
   * Once any species is caught, the picker never shows again (gate is count===0).
   * Not a page-load modal — only intercepts the first wild field click.
   */
  let starterModalOpen = false;

  function findStarterPokes(roster) {
    const byNum = {};
    (roster || []).forEach((p) => {
      if (STARTER_NUMS.indexOf(p.num) !== -1) byNum[p.num] = p;
    });
    return STARTER_NUMS.map((n) => byNum[n]).filter(Boolean);
  }

  function ensureStarterModal() {
    let el = document.querySelector(".goaded-starter");
    if (el) return el;
    el = document.createElement("div");
    el.className = "goaded-starter";
    el.hidden = true;
    el.innerHTML =
      '<div class="goaded-starter-panel" role="dialog" aria-modal="true" aria-labelledby="goaded-starter-title">' +
      '<button type="button" class="goaded-starter-x" data-starter-skip title="Skip (Esc)" aria-label="Skip">×</button>' +
      '<div class="goaded-starter-head">' +
      '<div class="goaded-starter-eyebrow">First catch</div>' +
      '<h2 id="goaded-starter-title">Choose your starter</h2>' +
      '<p class="goaded-starter-sub">Pick one — they unlock into your dex and become your fight partner.</p>' +
      "</div>" +
      '<div class="goaded-starter-grid" data-starter-grid></div>' +
      '<button type="button" class="btn btn-ghost goaded-starter-skip-btn" data-starter-skip>Skip for now</button>' +
      '<p class="goaded-starter-foot">Skip is soft — next wild can offer again until you catch any species.</p>' +
      "</div>";
    document.body.appendChild(el);
    return el;
  }

  function closeStarterModal(modal, onKey) {
    starterModalOpen = false;
    if (modal) modal.hidden = true;
    if (onKey) document.removeEventListener("keydown", onKey);
  }

  function grantStarter(poke, roster, max, wildBtn) {
    const vk = coerceVersionKey(poke, STARTER_VERSION);
    const map = unlockVersion(loadCaughtMap(), poke, vk);
    savePartner({ id: poke.id, versionKey: vk });
    document.querySelectorAll(".goadedex-cell.is-partner").forEach((el) => el.classList.remove("is-partner"));
    document.querySelectorAll(".goadedex-cell[data-poke-id]").forEach((el) => {
      if (el.getAttribute("data-poke-id") === poke.id) el.classList.add("is-partner");
    });
    refreshPartnerChip(poke);
    const count = speciesCaughtCount(map);
    refreshChip(count, max);
    refreshPrestigeUI(max);
    if (document.querySelector("[data-goatedex-grid]")) renderDexGrid(roster);
    const toast = ensureToast();
    toast.innerHTML =
      "Starter unlocked: <strong>" + poke.name + "</strong> · fight partner set · " + count + "/" + max;
    toast.classList.remove("is-shiny", "is-flee");
    toast.classList.add("is-on");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toast.classList.remove("is-on"), 3600);
    // Prefer dismiss over offering the clicked wild after the starter moment
    if (wildBtn && wildBtn.isConnected) wildBtn.remove();
  }

  function offerStarterPick(wildBtn, roster, max) {
    if (starterModalOpen) return;
    if (speciesCaughtCount(loadCaughtMap()) !== 0) return;
    const starters = findStarterPokes(roster);
    if (!starters.length) {
      // Roster missing starters — fall through would leave shopper stuck; dismiss wild only
      if (wildBtn && wildBtn.isConnected) wildBtn.remove();
      return;
    }
    const modal = ensureStarterModal();
    const grid = modal.querySelector("[data-starter-grid]");
    if (!grid) return;
    grid.innerHTML = "";
    starters.forEach((poke) => {
      const vk = coerceVersionKey(poke, STARTER_VERSION);
      const card = document.createElement("button");
      card.type = "button";
      card.className = "goaded-starter-card";
      card.setAttribute("data-starter-id", poke.id);
      card.setAttribute("aria-label", "Choose " + poke.name);
      const type = typeMeta(poke);
      card.style.setProperty("--starter-accent", type.accent || "#8CFF3A");
      const img = document.createElement("img");
      img.src = versionUrl(poke.num, vk);
      img.alt = "";
      img.decoding = "async";
      img.loading = "eager";
      img.style.imageRendering = "pixelated";
      img.onerror = () => {
        img.onerror = null;
        img.src = spriteUrlFallback(poke);
      };
      const name = document.createElement("span");
      name.className = "goaded-starter-name";
      name.textContent = poke.name;
      const typeEl = document.createElement("span");
      typeEl.className = "goaded-starter-type";
      typeEl.textContent = typePillLabel(type.name);
      typeEl.style.background = type.accent || "#8CFF3A";
      card.appendChild(img);
      card.appendChild(name);
      card.appendChild(typeEl);
      card.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeStarterModal(modal, onKey);
        grantStarter(poke, roster, max, wildBtn);
      });
      grid.appendChild(card);
    });

    const onSkip = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      closeStarterModal(modal, onKey);
      // Soft skip: leave the wild so shopper can click again; do not grant starter
      if (wildBtn) {
        wildBtn.classList.remove("is-catching", "is-battling");
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") onSkip(e);
    };

    modal.querySelectorAll("[data-starter-skip]").forEach((btn) => {
      btn.onclick = onSkip;
    });
    modal.onclick = (e) => {
      if (e.target === modal) onSkip(e);
    };
    document.addEventListener("keydown", onKey);
    starterModalOpen = true;
    modal.hidden = false;
  }

  function beginCatchAttempt(btn, poke, versionKey, shiny, roster, max) {
    const afterCatch = (names, anyShiny) => {
      const streak = bumpStreak();
      refreshStreakChip(streak);
      const count = speciesCaughtCount(loadCaughtMap());
      refreshChip(count, max);
      if (names.length === 1) {
        showToast(names[0], count, max, !!anyShiny);
      } else {
        const toast = ensureToast();
        const listed = names.map(function (n) { return "<strong>" + n + "</strong>"; }).join(" · ");
        toast.innerHTML = "Caught party! " + listed + " · " + count + "/" + max;
        toast.classList.toggle("is-shiny", !!anyShiny);
        toast.classList.remove("is-flee");
        toast.classList.add("is-on");
        clearTimeout(showToast._t);
        showToast._t = setTimeout(() => toast.classList.remove("is-on", "is-shiny", "is-flee"), 5200);
      }
      if (anyShiny) celebrateShiny(poke);
      refreshPrestigeUI(max);
      if (document.querySelector("[data-goatedex-grid]")) renderDexGrid(roster);
    };

    const doThrowOne = () => {
      throwPokeballAt(btn, () => {
        unlockVersion(loadCaughtMap(), poke, versionKey);
        afterCatch([poke.name], shiny);
      });
    };

    const onFlee = () => {
      resetStreak();
      refreshStreakChip(0);
      btn.classList.add("is-fled");
      showFleeToast(poke.name);
      setTimeout(() => {
        if (btn.isConnected) btn.remove();
      }, 500);
    };

    // Rare trainer challenge (not every spawn)
    if (shouldTrainerEncounter()) {
      btn.classList.add("is-battling");
      runTrainerBattle(roster, poke).then((result) => {
        btn.classList.remove("is-battling");
        if (result && result.won && result.party && result.party.length) {
          const previewNames = result.party.map(function (m) { return m.poke.name; });
          const previewToast = ensureToast();
          previewToast.innerHTML =
            "Party defeated! · " +
            previewNames.map(function (n) { return "<strong>" + n + "</strong>"; }).join(" · ");
          previewToast.classList.remove("is-shiny", "is-flee");
          previewToast.classList.add("is-on");
          clearTimeout(showToast._t);
          showToast._t = setTimeout(() => previewToast.classList.remove("is-on"), 4800);
          throwPokeballAt(btn, () => {
            let anyShiny = false;
            const names = [];
            result.party.forEach((m) => {
              unlockVersion(loadCaughtMap(), m.poke, m.versionKey);
              names.push(m.poke.name);
              if (m.shiny) anyShiny = true;
            });
            afterCatch(names, anyShiny);
            if (btn.isConnected) btn.remove();
          });
        } else {
          onFlee();
        }
      });
      return;
    }

    if (!shouldBattle(poke, shiny)) {
      doThrowOne();
      return;
    }

    btn.classList.add("is-battling");
    runBattleMinigame(poke, versionKey, shiny, roster).then((won) => {
      btn.classList.remove("is-battling");
      if (won) {
        doThrowOne();
      } else {
        onFlee();
      }
    });
  }

  function pokeballSrc(kind) {
    if (kind === "catch") return cfg.pokeballCatchUrl || cfg.pokeballUrl || "";
    if (kind === "open") return cfg.pokeballOpenUrl || cfg.pokeballUrl || "";
    if (kind === "flash") return cfg.pokeballFlashUrl || cfg.pokeballUrl || "";
    return cfg.pokeballUrl || "";
  }

  function spawnCatchSparks(field, x, y) {
    const wrap = document.createElement("div");
    wrap.className = "goaded-catch-sparks";
    wrap.style.left = x + "px";
    wrap.style.top = y + "px";
    wrap.setAttribute("aria-hidden", "true");
    const glyphs = ["✦", "✧", "★", "·", "✦", "✧"];
    for (let i = 0; i < 6; i++) {
      const s = document.createElement("span");
      s.textContent = glyphs[i];
      s.style.setProperty("--a", i * 60 + "deg");
      s.style.setProperty("--d", 18 + (i % 3) * 10 + "px");
      s.style.animationDelay = (i * 0.04).toFixed(2) + "s";
      wrap.appendChild(s);
    }
    field.appendChild(wrap);
    setTimeout(() => wrap.remove(), 900);
  }

  /**
   * Throw closed ball → play the catch GIF (open/shake) → success.
   * GIF provided by the shop owner for the capture moment.
   */
  function throwPokeballAt(btn, onHit) {
    const field = ensureField();
    const br = btn.getBoundingClientRect();
    const targetX = br.left + br.width / 2 + window.pageXOffset;
    const targetY = br.top + br.height / 2 + window.pageYOffset;

    const ball = document.createElement("div");
    ball.className = "goaded-pokeball";
    ball.setAttribute("aria-hidden", "true");
    const img = document.createElement("img");
    img.src = pokeballSrc("closed");
    img.alt = "";
    img.width = 72;
    img.height = 72;
    img.decoding = "async";
    img.draggable = false;
    img.style.imageRendering = "pixelated";
    ball.appendChild(img);

    const flash = document.createElement("div");
    flash.className = "goaded-catch-flash";
    flash.setAttribute("aria-hidden", "true");

    const side = Math.random() < 0.5 ? 0.22 : 0.78;
    const startX = window.pageXOffset + window.innerWidth * side;
    const startY = window.pageYOffset + window.innerHeight - 28;
    ball.style.left = startX + "px";
    ball.style.top = startY + "px";
    field.appendChild(ball);
    field.appendChild(flash);

    const dx = targetX - startX;
    const dy = targetY - startY;
    const lift = -Math.min(200, Math.max(100, Math.abs(dx) * 0.4 + 110));
    ball.style.setProperty("--dx", dx + "px");
    ball.style.setProperty("--dy", dy + "px");
    ball.style.setProperty("--lift", lift + "px");

    const pin = () => {
      ball.style.left = targetX + "px";
      ball.style.top = targetY + "px";
      ball.style.setProperty("--dx", "0px");
      ball.style.setProperty("--dy", "0px");
      ball.style.setProperty("--lift", "0px");
    };

    const wait = (ms) => new Promise((r) => setTimeout(r, ms));

    requestAnimationFrame(() => ball.classList.add("is-flying"));

    (async () => {
      await wait(200);
      ball.classList.remove("is-flying");
      pin();

      // Impact burst + swap to the catch GIF (open → shake loop)
      flash.style.left = targetX + "px";
      flash.style.top = targetY + "px";
      flash.classList.add("is-on");
      ball.classList.add("is-catching-gif");
      img.width = 96;
      img.height = 96;
      // Cache-bust so the GIF always restarts from frame 0
      const catchUrl = pokeballSrc("catch");
      img.src = catchUrl + (catchUrl.indexOf("?") === -1 ? "?" : "&") + "t=" + Date.now();

      btn.classList.add("is-sucking");
      await wait(120);
      btn.classList.remove("is-sucking");
      btn.classList.add("is-caught");

      // GIF at ~65ms/frame × 4 ≈ 260ms/loop — play ~1.5 loops
      await wait(420);

      ball.classList.add("is-success");
      spawnCatchSparks(field, targetX, targetY);
      if (typeof onHit === "function") onHit();

      await wait(380);
      ball.classList.remove("is-success", "is-catching-gif");
      ball.classList.add("is-done");
      flash.classList.remove("is-on");

      await wait(160);
      ball.remove();
      flash.remove();
      if (btn.isConnected) btn.remove();
    })();
  }

  function spawnInEmptySpace(dex) {
    const roster = dex.roster || [];
    if (!roster.length) return;
    document.querySelectorAll(".goaded-critter").forEach((el) => el.remove());
    const map = loadCaughtMap();
    const max = roster.length;
    refreshChip(speciesCaughtCount(map), max);

    const target = pickSpawnTarget(roster, map);
    const poke = target.poke;
    const versionKey = target.versionKey;
    const shiny = !!target.isShiny;

    const field = ensureField();
    const spots = pickEmptySpots(1);
    spots.forEach((spot, idx) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "goaded-critter" + (shiny ? " is-shiny" : "");
      btn.dataset.critterId = poke.id;
      btn.dataset.versionKey = versionKey;
      btn.setAttribute("aria-label", (shiny ? "Catch shiny " : "Catch ") + poke.name);
      btn.style.left = spot.x + "px";
      btn.style.top = spot.y + "px";
      btn.style.animationDelay = (idx * 0.12 + Math.random() * 0.35).toFixed(2) + "s";
      // Pre-clamp with budget size; re-clamped after pixel scale
      clampSpawnInView(btn);
      const img = document.createElement("img");
      img.src = versionUrl(poke.num, versionKey);
      img.alt = "";
      img.decoding = "async";
      img.loading = "eager";
      img.style.imageRendering = "pixelated";
      img.onerror = () => {
        img.onerror = null;
        img.src = spriteUrlFallback(poke);
      };
      btn.appendChild(img);
      applyPixelScale(img, btn);
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (
          btn.classList.contains("is-caught") ||
          btn.classList.contains("is-catching") ||
          btn.classList.contains("is-battling") ||
          btn.classList.contains("is-fled")
        )
          return;
        // First-catch only: intercept wild click → Choose your starter (not page-load)
        if (speciesCaughtCount(loadCaughtMap()) === 0) {
          offerStarterPick(btn, roster, max);
          return;
        }
        btn.classList.add("is-catching");
        beginCatchAttempt(btn, poke, versionKey, shiny, roster, max);
      });
      field.appendChild(btn);
    });
  }

  function renderDexGrid(roster) {
    const root = document.querySelector("[data-goatedex-grid]");
    if (!root) return;
    const cells = root.querySelector("[data-goatedex-cells]");
    const progress = root.querySelector("[data-goatedex-progress]");
    if (!cells) return;
    const max = roster.length;
    const map = loadCaughtMap();
    const caughtCount = speciesCaughtCount(map);
    if (progress) progress.textContent = caughtCount + " / " + max;
    refreshChip(caughtCount, max);
    refreshPrestigeUI(max);
    const partner = resolvePartner(roster, map);
    refreshPartnerChip(partner ? partner.poke : null);

    const filterBtns = root.querySelectorAll("[data-dex-filter]");
    let mode = root.dataset.filter || "caught";
    // Drop legacy shiny filter if still present in DOM
    filterBtns.forEach((b) => {
      const key = b.getAttribute("data-dex-filter");
      if (key === "shiny") {
        b.hidden = true;
        if (mode === "shiny") {
          mode = "caught";
          root.dataset.filter = "caught";
        }
        return;
      }
      b.classList.toggle("is-active", key === mode);
      b.onclick = () => {
        root.dataset.filter = b.getAttribute("data-dex-filter");
        renderDexGrid(roster);
      };
    });

    const frag = document.createDocumentFragment();
    const isCaught = (p) => unlockedFor(map, p.id).length > 0;

    if (mode === "all") {
      const page = Number(root.dataset.page || 0);
      const pageSize = 200;
      const slice = roster.slice(page * pageSize, page * pageSize + pageSize);
      slice.forEach((p) => frag.appendChild(makeCell(p, map)));
      cells.innerHTML = "";
      cells.appendChild(frag);
      let pager = root.querySelector("[data-dex-pager]");
      if (!pager) {
        pager = document.createElement("div");
        pager.setAttribute("data-dex-pager", "");
        pager.style.cssText = "display:flex;gap:8px;flex-wrap:wrap;margin-top:12px";
        root.appendChild(pager);
      }
      const pages = Math.ceil(roster.length / pageSize);
      pager.innerHTML = "";
      for (let i = 0; i < pages; i++) {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "btn btn-ghost btn-sm" + (i === page ? " is-active" : "");
        b.textContent = String(i + 1);
        b.onclick = () => {
          root.dataset.page = String(i);
          renderDexGrid(roster);
        };
        pager.appendChild(b);
      }
      return;
    }

    const list =
      mode === "missing"
        ? roster.filter((p) => !isCaught(p)).slice(0, 300)
        : roster.filter((p) => isCaught(p));

    list.forEach((p) => frag.appendChild(makeCell(p, map)));
    cells.innerHTML = "";
    cells.appendChild(frag);
    const pager = root.querySelector("[data-dex-pager]");
    if (pager) pager.innerHTML = "";
  }

  const artPrefKey = "goaded_art_style_v1";
  function loadArtPrefs() {
    try {
      const raw = JSON.parse(localStorage.getItem(artPrefKey) || "{}");
      return raw && typeof raw === "object" ? raw : {};
    } catch (_) {
      return {};
    }
  }
  function saveArtPref(pokeId, styleKey) {
    const prefs = loadArtPrefs();
    prefs[pokeId] = styleKey;
    localStorage.setItem(artPrefKey, JSON.stringify(prefs));
  }

  function ensureArtModal() {
    let modal = document.querySelector(".goadedex-art-modal");
    if (modal) return modal;
    modal = document.createElement("div");
    modal.className = "goadedex-art-modal";
    modal.hidden = true;
    modal.innerHTML =
      '<div class="goadedex-art-dialog" role="dialog" aria-modal="true" aria-label="Sprite art styles">' +
      '<button type="button" class="goadedex-art-close" aria-label="Close">×</button>' +
      '<div class="goadedex-art-head"><div class="dex-num" data-art-num></div><h3 data-art-name></h3></div>' +
      '<div class="goadedex-art-stage"><img data-art-preview alt="" width="160" height="160"></div>' +
      '<p class="goadedex-art-hint">Unveil all their alternate arts! Locked slots stay a mystery — catch them all!!</p>' +
      '<div class="goadedex-art-styles" data-art-styles></div>' +
      "</div>";
    document.body.appendChild(modal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal || e.target.classList.contains("goadedex-art-close")) closeArtModal();
    });
    return modal;
  }

  function closeArtModal() {
    const modal = document.querySelector(".goadedex-art-modal");
    if (modal) modal.hidden = true;
  }

  let artModalToken = 0;
  function versionButtonLabel(key) {
    const meta = VERSION_META[key] || { label: key, shiny: false };
    // Locked stay ????; unlocked can show gen — star marks alt/shiny without saying "Shiny"
    return meta.shiny ? "✦ " + meta.label : meta.label;
  }
  function openArtModal(p) {
    const modal = ensureArtModal();
    const token = ++artModalToken;
    const map = loadCaughtMap();
    const unlockedList = [];
    const unlockedSeen = {};
    unlockedFor(map, p.id).forEach((k) => {
      const ck = coerceVersionKey(p, k);
      if (!unlockedSeen[ck]) {
        unlockedSeen[ck] = true;
        unlockedList.push(ck);
      }
    });
    const unlocked = new Set(unlockedList);
    const prefs = loadArtPrefs();
    let currentKey = prefs[p.id];
    if (!currentKey || !unlocked.has(currentKey)) {
      currentKey = displayKeyFor(p, map);
    }
    if (!currentKey || !unlocked.has(currentKey)) {
      currentKey = unlockedList[0] || null;
    }
    modal.querySelector("[data-art-num]").textContent = "#" + p.num;
    modal.querySelector("[data-art-name]").textContent = p.name;
    const preview = modal.querySelector("[data-art-preview]");
    const stylesEl = modal.querySelector("[data-art-styles]");
    stylesEl.innerHTML = "";
    preview.onerror = null;
    preview.removeAttribute("src");

    const setPreview = (key) => {
      if (token !== artModalToken) return;
      const url = versionUrl(p.num, key);
      preview.style.imageRendering = "pixelated";
      preview.onerror = () => {
        if (token !== artModalToken) return;
        // Never leave a broken icon — fall back hard
        preview.onerror = null;
        preview.src = spriteUrlFallback(p);
      };
      preview.src = url;
      stylesEl.querySelectorAll("button").forEach((b) => {
        b.classList.toggle("is-active", b.dataset.style === key);
      });
    };

    if (currentKey) setPreview(currentKey);
    else preview.src = spriteUrlFallback(p);

    // Only render versions that are plausible for this species
    const keys = candidateKeys(p).filter((k) => likelyAvailable(p, k));
    keys.forEach((key) => {
      const meta = VERSION_META[key] || { label: key, shiny: false };
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "btn btn-ghost btn-sm";
      btn.dataset.style = key;

      if (!unlocked.has(key)) {
        btn.classList.add("is-mystery");
        btn.textContent = "????";
        btn.disabled = true;
        btn.title = "Not unlocked yet";
        stylesEl.appendChild(btn);
        probeVersion(p.num, key).then((ok) => {
          if (token !== artModalToken) return;
          if (!ok) {
            btn.hidden = true;
            setCachedAvail(p.num, key, false);
          }
        });
        return;
      }

      // Unlocked: trust the unlock — never demote to ???? if probe flakes (iPad/Safari)
      const url = versionUrl(p.num, key);
      btn.textContent = versionButtonLabel(key);
      if (meta.shiny) btn.classList.add("is-shiny-ver");
      btn.disabled = false;
      btn.title = "View this version";
      if (key === currentKey) btn.classList.add("is-active");
      btn.onclick = () => {
        if (token !== artModalToken) return;
        saveArtPref(p.id, key);
        currentKey = key;
        setPreview(key);
        const root = document.querySelector("[data-goatedex-grid]");
        if (root) {
          loadDex().then((dex) => renderDexGrid(dex.roster || []));
        }
      };
      stylesEl.appendChild(btn);
      // Soft probe only — never hide an unlocked button (iPad probes flake)
      probeVersion(p.num, key).then((ok) => {
        if (token !== artModalToken) return;
        if (!ok) setCachedAvail(p.num, key, false);
      });
    });

    modal.hidden = false;
  }

  function makeVersionProgress(p, map) {
    const unlocked = new Set(unlockedFor(map, p.id).map((k) => coerceVersionKey(p, k)));
    const keys = availableKeysSync(p);
    const unlockedCount = keys.filter((k) => unlocked.has(k)).length;
    const count = document.createElement("div");
    count.className = "dex-ver-count";
    count.textContent = unlockedCount + "/" + keys.length;
    count.title = unlockedCount + " of " + keys.length + " art versions unlocked";
    return count;
  }

  function makeCell(p, map) {
    const unlocked = unlockedFor(map, p.id);
    const isCaught = unlocked.length > 0;
    const showKey = displayKeyFor(p, map);
    const showingShiny = showKey ? isShinyKey(showKey) : false;
    const cell = document.createElement("div");
    cell.className =
      "goadedex-cell" +
      (isCaught ? " is-caught" : " is-unknown") +
      (showingShiny ? " is-shiny" : "");
    cell.title = isCaught ? p.name + " — tap to change art style" : "Not caught yet";
    const num = document.createElement("div");
    num.className = "dex-num";
    num.textContent = "#" + p.num;
    cell.appendChild(num);
    if (isCaught) {
      if (showingShiny) {
        const badge = document.createElement("div");
        badge.className = "dex-style";
        badge.textContent = "✦";
        badge.title = "Shiny art";
        cell.appendChild(badge);
      }
      const img = document.createElement("img");
      img.src = versionUrl(p.num, showKey);
      img.alt = p.name;
      img.loading = "lazy";
      img.width = 72;
      img.height = 72;
      img.decoding = "async";
      img.style.imageRendering = "pixelated";
      img.onerror = () => {
        img.onerror = null;
        img.src = spriteUrlFallback(p);
      };
      cell.appendChild(img);
      const name = document.createElement("div");
      name.className = "dex-name";
      name.textContent = p.name;
      cell.appendChild(name);
      cell.appendChild(makeVersionProgress(p, map));
      cell.dataset.pokeId = p.id;
      const prefP = loadPartner();
      if (prefP && prefP.id === p.id) cell.classList.add("is-partner");
      const partnerBtn = document.createElement("button");
      partnerBtn.type = "button";
      partnerBtn.className = "dex-partner-btn";
      partnerBtn.title = "Set partner";
      partnerBtn.setAttribute("aria-label", "Set partner: " + p.name);
      if (cell.classList.contains("is-partner")) {
        partnerBtn.innerHTML = '<span aria-hidden="true">★</span>';
      } else {
        partnerBtn.innerHTML =
          '<svg class="dex-partner-ico" viewBox="0 0 16 16" aria-hidden="true">' +
          '<path fill="currentColor" d="M2.2 1.1l3.2 1.1 1.1 3.2-1.5 1.5-2.8-2.8zm11.6 0l-3.2 1.1-1.1 3.2 1.5 1.5 2.8-2.8zM7.1 7.9L4.4 13.6l1.3.6 1.7-3.5 1.7 3.5 1.3-.6-2.7-5.7z"/>' +
          '</svg>';
      }
      partnerBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        setPartnerFromPoke(p, map);
        loadDex().then((dex) => renderDexGrid(dex.roster || []));
      });
      cell.appendChild(partnerBtn);
      cell.tabIndex = 0;
      cell.setAttribute("role", "button");
      cell.addEventListener("click", () => openArtModal(p));
      cell.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openArtModal(p);
        }
      });
    } else {
      const mark = document.createElement("div");
      mark.className = "dex-unknown";
      mark.setAttribute("aria-hidden", "true");
      mark.textContent = "?";
      cell.appendChild(mark);
      const name = document.createElement("div");
      name.className = "dex-name";
      name.textContent = "???";
      cell.appendChild(name);
      // No version chips until first catch — avoids spoiling icon shiny slot counts
    }
    return cell;
  }

  /* No wild spawns on cart / checkout / order-status paths (Liquid sets GOADED.noWild on template 'cart'). */
  function wildSpawnBlocked() {
    try {
      if (window.GOADED && window.GOADED.noWild === true) return true;
      if (document.body && document.body.classList.contains("goaded-no-wild")) return true;
      let p = String(location.pathname || "/").toLowerCase();
      p = p.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/, ""); // strip /en-us style locale prefix
      if (/^\/(?:cart|checkout|checkouts|orders)(?:\/|$)/.test(p)) return true;
      if (/^\/\d+\/(?:checkouts|orders)(?:\/|$)/.test(p)) return true;
      if (/\/(?:thank[-_]you|order[-_]status)(?:\/|$)/.test(p)) return true;
      return false;
    } catch (_) {
      return false;
    }
  }

  function boot() {
    loadDex().then((dex) => {
      if (!dex.roster || !dex.roster.length) return;
      sanitizeCaughtMap(loadCaughtMap(), dex.roster);
      if (wildSpawnBlocked()) {
        document.querySelectorAll(".goaded-critter").forEach((el) => el.remove());
      } else {
        spawnInEmptySpace(dex);
      }
      const grid = document.querySelector("[data-goatedex-grid]");
      if (grid && !grid.dataset.filter) grid.dataset.filter = "all";
      renderDexGrid(dex.roster);
      refreshPrestigeUI(dex.roster.length);
      refreshStreakChip(loadStreak());
      bindShareCardButton();
      try { window.__GOADED_ROSTER_LEN__ = dex.roster.length; } catch (_) {}
      const pBtn = document.querySelector("[data-prestige-btn]");
      if (pBtn) pBtn.onclick = () => confirmPrestige(dex.roster);
      const hBtn = document.querySelector("[data-hard-reset-btn]");
      if (hBtn) hBtn.onclick = () => confirmHardReset(dex.roster);
      mountLabPrestigePanel();
      mountTwitchLink();
      try {
        window.__GOADED_LAB__ = {
          enabled: isLabTestToolsEnabled(),
          setPrestige: labSetPrestige,
          bumpPrestige: labBumpPrestige,
          themeId: LAB_THEME_ID,
        };
      } catch (_) {}
      listeners.push(function onSynced() {
        sanitizeCaughtMap(loadCaughtMap(), dex.roster);
        refreshChip(speciesCaughtCount(loadCaughtMap()), dex.roster.length);
        refreshPrestigeUI(dex.roster.length);
        renderDexGrid(dex.roster);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
